webpackJsonp([15],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Misc = {
    callLater: function callLater(cb, delay) {
        if (delay === undefined) {
            delay = 0;
        }
        return setTimeout(cb, delay);
    },

    callEvery: function callEvery(cb, delay) {
        if (delay === undefined) {
            delay = 0;
        }
        return setInterval(cb, delay);
    },

    scrollToTop: function scrollToTop() {
        var scrollDuration = 250;
        var scrollStep = -window.scrollY / (scrollDuration / 15);
        var scrollInterval = setInterval(function () {
            if (window.scrollY != 0) {
                window.scrollBy(0, scrollStep);
            } else {
                clearInterval(scrollInterval);
            }
        }, 15);
    },

    scrollLeftBy: function scrollLeftBy($elm, val, cb) {
        /*const toScroll = $elm.scrollLeft() + val;
        $elm.stop(true, true).animate({
            scrollLeft: toScroll
        }, 250);
        Misc.callLater(cb, 250);*/
    },

    isMobile: function isMobile() {
        return window.innerWidth < 600;
    },


    scrollToElm: function scrollToElm($elm) {
        if (Misc.scrolling) return;
        Misc.scrolling = true;
        if ($elm.length > 0) {
            scrollIt($elm[0]);
        }
        Misc.callLater(function () {
            Misc.scrolling = false;
        }, 250);
    },

    isVisibleOnScreen: function isVisibleOnScreen(sel) {
        var $win = $(window);
        var $elm = $(sel);
        var docViewTop = $win.scrollTop();
        var docViewBottom = docViewTop + $win.height();
        var elemTop = $elm.offset().top;
        var elemBottom = elemTop; // + $elm.height();
        return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    isMostlyVisibleOnScreen: function isMostlyVisibleOnScreen(sel) {
        var $win = $(window);
        var $elm = $(sel);
        var docViewTop = $win.scrollTop();
        var docViewBottom = docViewTop + $win.height();
        var elemTop = $elm.offset().top;
        var elemBottom = elemTop + $elm.height() / 2;
        return elemBottom <= docViewBottom && elemTop >= docViewTop;
    },
    hasScroll: function hasScroll($elm, cb) {
        if ($elm && $elm.length > 0) {
            if (!Misc.scrollCounter) Misc.scrollCounter = 0;
            var scrollHeight = $elm[0].scrollHeight;
            var clientHeight = $elm[0].clientHeight;
            if (clientHeight > 0 && Misc.scrollCounter > 0) {
                cb(clientHeight < scrollHeight);
                Misc.scrollCounter = 0;
            } else if (Misc.scrollCounter < 10) {
                Misc.scrollCounter++;
                Misc.callLater(function () {
                    Misc.hasScroll($elm, cb);
                }, 100);
            } else {
                cb(false);
                Misc.scrollCounter = 0;
            }
        } else {
            cb(false);
            Misc.scrollCounter = 0;
        }
    },
    setOverlay: function setOverlay(showOverlay, showLoader) {
        var $overlay = $("#overlay");
        var $loader = $(".loader", $overlay);
        if (showOverlay) {
            $overlay.removeClass("hidden");
            $("#sections").addClass("blur");
            $("footer.app-footer").addClass("blur");
            $("header.main-header nav").addClass("blur");
            $("body").addClass("no-scroll");
        } else {
            $overlay.addClass("hidden");
            $("#sections").removeClass("blur");
            $("footer.app-footer").removeClass("blur");
            $("header.main-header nav").removeClass("blur");
            $("body").removeClass("no-scroll");
        }
        if (showLoader) {
            $loader.addClass("active").removeClass("hidden");
        } else {
            $loader.removeClass("active").addClass("hidden");
        }
    },

    randomNumber: function randomNumber(min, max) {
        if (!min) min = 0;
        if (!max) max = 1000000000000;
        return Math.ceil(Math.random() * (max - min) + min);
    },

    isNumber: function isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    },
    sort: function sort(list, sortOn, reverse) {
        if (list && list.length > 0) {
            var sortStr = function sortStr(a, b) {
                if (a[sortOn] < b[sortOn]) return -1;
                if (a[sortOn] > b[sortOn]) return 1;
                return 0;
            };
            var sortNum = function sortNum(a, b) {
                return b[sortOn] - a[sortOn];
            };

            if (list && list.length > 0) {
                if (this.isNumber(list[0][sortOn])) list.sort(sortNum);else list.sort(sortStr);
            }
            if (reverse) {
                list.reverse();
            }
        }
    },
    cloneAry: function cloneAry(list) {
        return list.slice(0);
    },
    cloneObj: function cloneObj(obj) {
        if (obj) return $.extend({}, obj);
        return null;
    },
    convertObjToArray: function convertObjToArray(obj) {
        return $.map(obj, function (el) {
            return el;
        });
    },
    getOne: function getOne(list) {
        var idx = Misc.randomNumber(0, list.length - 1);
        return list[idx];
    },
    joinArray: function joinArray(ary1, ary2) {
        return ary1 && ary2 ? ary1.concat(ary2) : ary1;
    },
    shadeColor: function shadeColor(color, percent) {
        if (!color) color = "454545";
        var R = parseInt(color.substring(1, 3), 16);
        var G = parseInt(color.substring(3, 5), 16);
        var B = parseInt(color.substring(5, 7), 16);
        var rgbColor = "rgba(" + R + "," + G + "," + B + ", " + percent + ")"; //rgba(0, 0, 0, 0.5);
        return rgbColor;
    }
};

module.exports = Misc;

function scrollIt(destination) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
    var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'linear';
    var callback = arguments[3];


    var easings = {
        linear: function linear(t) {
            return t;
        },
        easeInQuad: function easeInQuad(t) {
            return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
            return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
            return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
            return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
            return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
            return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
            return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
            return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
            return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
            return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
            return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
    };

    var start = window.pageYOffset;
    var startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

    var documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
    var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
    var destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
    var destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

    destinationOffsetToScroll = Math.max(0, destinationOffsetToScroll - 76);

    if ('requestAnimationFrame' in window === false) {
        window.scroll(0, destinationOffsetToScroll);
        if (callback) {
            callback();
        }
        return;
    }

    function scroll() {
        var now = 'now' in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        window.scroll(0, Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start));

        if (window.pageYOffset === destinationOffsetToScroll) {
            if (callback) {
                callback();
            }
            return;
        }

        requestAnimationFrame(scroll);
    }

    scroll();
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var onScroll = function onScroll() {
    for (var uid in Event.scrollCbs) {
        Event.scrollCbs[uid]();
    }
};

var onResize = function onResize() {
    if (Event.busy) return;
    Event.busy = true;
    setTimeout(function () {
        for (var uid in Event.resizeCbs) {
            Event.resizeCbs[uid]();
        }
        Event.busy = false;
    }, 100);
};

var onBodyTap = function onBodyTap(e) {
    for (var uid in Event.tapCBs) {
        Event.tapCBs[uid](e);
    }
};

var Event = {
    tap: function tap(selector, cb, parent, remove) {
        var $item = parent ? $(parent) : $(document);
        if (remove) $item.off("tap click", selector, cb);else $item.on("tap click", selector, cb);
    },
    enter: function enter(selector, cb, parent, remove) {
        var $item = parent ? $(parent) : $(document);
        var fn = function fn(e) {
            if (e.which == 13) {
                cb(e);
            }
        };
        if (remove) $item.off("keypress", selector, fn);else $item.on("keypress", selector, fn);
    },
    listen: function listen(selector, type, cb, parent, remove) {
        var $item = parent ? $(parent) : $(document);
        if (remove) $item.off(type, selector, cb);else $item.on(type, selector, cb);
    },
    elmListen: function elmListen($elm, type, cb, remove) {
        if (remove) $elm.off(type, cb);else $elm.on(type, cb);
    },
    listenGlobal: function listenGlobal(type, cb, remove) {
        if (remove) $(document).off(type, cb);else $(document).on(type, cb);
    },
    dispatch: function dispatch(name, data) {
        var event = $.Event(name);
        event.eventData = data;
        $(document).trigger(event);
    },
    bodyTap: function bodyTap(cb, remove) {
        if (remove) {
            Event.listenGlobal("tap click", cb, remove);
        } else {
            setTimeout(function () {
                Event.listenGlobal("tap click", cb, remove);
            }, 0);
        }
    },
    watchBodyTaps: function watchBodyTaps(uid, cb, remove) {
        if (!Event.tapCBs) {
            Event.tapCBs = {};
            Event.listenGlobal("tap click", onBodyTap);
        }
        if (!Event.tapCBs[uid]) {
            Event.tapCBs[uid] = cb;
        } else if (remove) {
            delete Event.tapCBs[uid];
            if (Object.keys(Event.tapCBs).length === 0 && Event.tapCBs.constructor === Object) {
                delete Event.tapCBs;
                Event.listenGlobal("tap click", onBodyTap, true);
            }
        }
    },
    scroll: function scroll(uid, cb, remove) {
        if (!Event.scrollCbs) {
            Event.scrollCbs = {};
            Event.listenGlobal("scroll", onScroll);
        }
        if (!Event.scrollCbs[uid]) {
            Event.scrollCbs[uid] = cb;
        } else if (remove) {
            delete Event.scrollCbs[uid];
            if (Object.keys(Event.scrollCbs).length === 0 && Event.scrollCbs.constructor === Object) {
                delete Event.scrollCbs;
                Event.listenGlobal("scroll", onScroll, true);
            }
        }
    },
    resize: function resize(uid, cb, remove) {
        if (!Event.resizeCbs) {
            Event.resizeCbs = {};
            $(window).on("resize", onResize);
        }
        if (!Event.resizeCbs[uid]) {
            Event.resizeCbs[uid] = cb;
        } else if (remove) {
            delete Event.resizeCbs[uid];
            if (Object.keys(Event.resizeCbs).length === 0 && Event.resizeCbs.constructor === Object) {
                delete Event.resizeCbs;
                $(window).off("resize", onResize);
            }
        }
    }
};
module.exports = Event;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Misc = __webpack_require__(1);
var _Dater = __webpack_require__(11);
var _Sort = __webpack_require__(18);

var Looper = {
    forEach: function forEach(dataOrAry, fn) {
        for (var propName in dataOrAry) {
            var propVal = dataOrAry[propName];
            fn(propName, propVal);
        }
    },
    forEach$: function forEach$($items, fn) {
        var n = $items.length;
        for (var i = 0; i < n; i++) {
            fn($items.eq(i), i);
        }
    },
    array: function array(ary, fn, doClone) {
        var n = ary ? ary.length : 0;
        for (var i = 0; i < n; i++) {
            if (doClone) fn(_Misc.cloneObj(ary[i]), i);else fn(ary[i], i);
        }
    },
    arrayLimit: function arrayLimit(ary, fn, startIdx, endIdx) {
        var n = ary ? ary.length : 0;
        n = Math.min(n, endIdx);
        for (var i = startIdx; i < n; i++) {
            fn(ary[i], i);
        }
    },
    resetForm: function resetForm($inputs) {
        var n = $inputs.length;
        for (var i = 0; i < n; i++) {
            var $item = $inputs.eq(i);
            if ($item.attr("disabled")) continue;
            $item.val("");
            $item.trigger("reset");
        }
    },
    fetchArrayFromFBObj: function fetchArrayFromFBObj(obj, sortOn, reverse, markName, markValue) {
        var ary = [];
        for (var prop in obj) {
            var item = obj[prop];
            item.id = prop;
            if (markName) item[markName] = markValue;
            if (item.children) item.children = Looper.fetchArrayFromFBObj(item.children, sortOn, reverse, markName, markValue);
            ary.push(item);
        }
        if (!sortOn) {
            ary.sort(function (a, b) {
                return parseInt(a.updated_on) < parseInt(b.updated_on);
            });
        } else {
            ary.sort(function (a, b) {
                return a[sortOn] < b[sortOn];
            });
        }

        if (reverse) ary = ary.reverse();
        return ary;
    },
    parseFBObj: function parseFBObj(obj, sortOn, reverse, typeName) {
        var ary = [];
        for (var prop in obj) {
            var item = obj[prop];
            item.id = prop;
            if (typeName) item.kind = typeName;
            if (item.children) item.children = Looper.fetchArrayFromFBObj(item.children, sortOn, reverse, markName, markValue);
            ary.push(item);
        }
        if (!sortOn) {
            _Sort.updated_on(ary);
        } else {
            _Sort[sortOn](ary);
        }

        if (reverse) ary = ary.reverse();
        return ary;
    },
    updateChildren: function updateChildren(list, propsAry, markAsChild) {
        Looper.array(list, function (item) {
            if (item.children) {
                Looper.array(item.children, function (child) {
                    Looper.array(propsAry, function (propName) {
                        child[propName] = item[propName];
                        if (markAsChild) {
                            child.parentId = item.id;
                        }
                    });
                });
            }
        });
    },
    fetchItemByProp: function fetchItemByProp(list, propName, propValue) {
        if (list && propValue) {
            var n = list.length;
            for (var i = 0; i < n; i++) {
                var item = list[i];
                var itemVal = item[propName];
                if (typeof itemVal === "string") {
                    if (itemVal.toLowerCase() == propValue.toLowerCase()) return item;
                } else if (item[propName] == propValue) {
                    return item;
                }

                if (item.children) {
                    var m = item.children.length;
                    for (var j = 0; j < m; j++) {
                        var child = item.children[j];
                        if (child[propName] == propValue) return child;
                    }
                }
            }
        }
        return null;
    },
    replaceOrAddItemInArrayByProp: function replaceOrAddItemInArrayByProp(list, propName, newItem, sortOn, doDelete) {
        var listClone = _Misc.cloneAry(list);
        var n = listClone.length;
        var replaced = false;
        for (var i = 0; i < n; i++) {
            var item = listClone[i];
            if (item[propName] === newItem[propName]) {
                replaced = true;
                if (doDelete) {
                    listClone.splice(i, 1);
                    break;
                } else {
                    if (newItem.recentlyCreated) delete newItem.recentlyCreated;
                    newItem.recentlyUpdated = true;
                    listClone[i] = newItem;
                }
            }
        }
        if (!replaced) {
            newItem.recentlyCreated = true;
            listClone.push(newItem);
            _Misc.sort(listClone, sortOn);
        }
        return listClone;
    },
    purify: function purify(obj) {
        for (var propName in obj) {
            var propVal = obj[propName];
            if (!propVal) delete obj[propName];
        }
    },
    fetchItemsForDates: function fetchItemsForDates(list, sd, ed, dateProperty) {
        var datedList = [];
        Looper.array(list, function (item) {
            if (_Dater.isInRange(sd, ed, item[dateProperty])) {
                datedList.push(_Misc.cloneObj(item));
            }
        });
        return datedList;
    },
    fetchBudgetItemsForDates: function fetchBudgetItemsForDates(list, sd, ed, dateProperty) {
        var datedList = [];
        Looper.array(list, function (item) {
            if (!item.option1) {
                if (_Dater.isInRange(sd, ed, item[dateProperty])) {
                    datedList.push(_Misc.cloneObj(item));
                }
            }
        });
        return datedList;
    }
};

module.exports = Looper;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _StringTools = __webpack_require__(8);

var Formatter = {
    monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],

    phone: function phone(str) {
        str = str.replace(/\D/g, '');
        str = str.replace(/(\d{3})(\d{3})(\d{4})/, "($1)-$2-$3");
        return str;
    },
    money: function money(str, allowNegative, doShort) {
        if (!str) str = "";
        str = str.toString();
        if (str && str.charAt(0) == "$") str = str.substring(1);
        if (str && str.indexOf("$") > -1) str = _StringTools.searchAndReplace(str, "$", "");
        if (str && str.indexOf("-") > -1 && !allowNegative) str = _StringTools.searchAndReplace(str, "-", "");
        if (str && str.indexOf(",") > -1) str = _StringTools.searchAndReplace(str, ",", "");
        if (str.hasOwnProperty("replace")) str = str.replace(/[^\d.-]/g, '');
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2 /* this might not be necessary */
        });
        var retStr = formatter.format(str);
        var num = Formatter.numberFromAmount(retStr, allowNegative);

        if (num === 0) retStr = formatter.format("0");
        if (doShort) {
            var fracPart = num - parseInt(num);
            if (fracPart === 0) retStr = Formatter.shortMoney(retStr, allowNegative);
        }
        return retStr;
    },
    shortMoney: function shortMoney(str, allowNegative) {
        var m = Formatter.money(str, allowNegative);
        return m.slice(0, -3);
    },
    percentage: function percentage(str, allowNegative) {
        if (!str) str = "";
        str = str.toString();
        if (str && str.indexOf("%") > -1) str = _StringTools.searchAndReplace(str, "%", "");
        if (str.hasOwnProperty("replace")) str = str.replace(/[^\d.-]/g, '');
        var num = Formatter.numberFromAmount(str, allowNegative);
        return num + "%";
    },
    numberFromAmount: function numberFromAmount(str, allowNegative) {

        var num = parseFloat(str.replace(/[^\d.-]/g, ''));
        if (allowNegative) {
            var isNeg = str.charAt(0) == "-";
            if (isNeg) num = -num;
        }
        if (isNaN(num)) return 0;
        return allowNegative ? num : Math.abs(num);
    },
    dayDate: function dayDate(date) {
        var day = this.dayNames[date.getDay()];
        var mDate = this.singleDate(date);
        return day + ", " + mDate;
    },
    singleDate: function singleDate(date, short, doYY) {
        if (!(date instanceof Date)) date = new Date(date);
        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        if (doYY) {
            year = year.toString().substr(-2);
        }
        var dStr = this.monthNames[monthIndex] + " " + day + ", " + year;
        if (short) {
            var mIdx = monthIndex + 1;
            var mStr = mIdx > 9 ? mIdx : "0" + mIdx;
            var dayStr = day > 9 ? day : "0" + day;
            dStr = mStr + "/" + dayStr + "/" + year.toString().substr(-2);
        }
        return dStr;
    },
    htmlDate: function htmlDate(date) {
        if (!(date instanceof Date)) date = new Date(date);
        var mDay = date.getDate();
        var wDay = this.dayNamesShort[date.getDay()];
        var month = this.monthNames[date.getMonth()];
        var year = date.getFullYear();
        var dStr = "<span class='date'>" + mDay + "</span>";
        dStr += "<span class='wk-day'>" + wDay + "</span>";
        dStr += "<span class='mo'>" + month + "</span>";
        dStr += "<span class='yy'>" + year + "</span>";
        return dStr;
    },
    monthDate: function monthDate(date) {
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        return this.monthNames[monthIndex] + ", " + year;
    },
    yearDate: function yearDate(date) {
        var year = date.getFullYear();
        return year;
    },
    dateRange: function dateRange(startDate, endDate) {
        var d1 = startDate.getDate();
        var m1 = startDate.getMonth();
        var y1 = startDate.getFullYear();
        var d2 = endDate.getDate();
        var m2 = endDate.getMonth();
        var y2 = endDate.getFullYear();
        var dateStr = "";
        if (y1 === y2) {
            if (m1 === m2) {
                var mLb = this.monthNames[m1];
                dateStr = mLb + " " + d1 + " - " + d2 + ", " + y1;
            } else {
                var m1Lb = this.monthNames[m1];
                var m2Lb = this.monthNames[m2];
                dateStr = m1Lb + " " + d1 + " - " + m2Lb + " " + d2 + ", " + y1;
            }
        } else {
            var _m1Lb = this.monthNames[m1];
            var _m2Lb = this.monthNames[m2];
            dateStr = _m1Lb + " " + d1 + ", " + y1 + " - " + _m2Lb + " " + d2 + ", " + y2;
        }
        return dateStr;
    }
};

module.exports = Formatter;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(54);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list, options);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove, transformResult;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    transformResult = options.transform(obj.css);
	    
	    if (transformResult) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = transformResult;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css. 
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var FireAuth = __webpack_require__(12);
var Sanitizer = __webpack_require__(41);
var Loader = __webpack_require__(9);
var Dater = __webpack_require__(11);
var Formatter = __webpack_require__(5);
var StringTools = __webpack_require__(8);

var FB = {
    onResolve: function onResolve(cb, cbData) {
        return function (data) {
            if (cb) cb(data, cbData);
        };
    },
    onReject: function onReject(cb) {
        return function (data) {
            if (cb) cb(data);
        };
    },
    invoke: function invoke(cb) {
        if (FB.busy) return;
        FB.busy = true;
        Loader.script("/vendor/firebase.js", "firebase", function () {
            FB.init();
            FB.busy = false;
            cb();
        });
    },

    init: function init() {
        if (!firebase) return;
        var config = {
            apiKey: "AIzaSyDYH5EU52_z-SR1pjQe2MEdE_OUUXapKdw",
            authDomain: "iexpenseonline.firebaseapp.com",
            databaseURL: "https://iexpenseonline.firebaseio.com",
            projectId: "iexpenseonline",
            storageBucket: "gs://iexpenseonline.appspot.com",
            messagingSenderId: "769386440496"
        };
        firebase.initializeApp(config);
        FireAuth.init();
        FB.initialized = true;
    },


    //-------PROTECTED
    readProtectedData: function readProtectedData(destination, cb) {
        firebase.database().ref('/protected/' + destination + "/").once('value').then(FB.onResolve(cb), FB.onReject(cb));
    },
    writeProtectedData: function writeProtectedData(destination, data, cb) {
        Sanitizer.invoke(data);
        data.updated_on = firebase.database.ServerValue.TIMESTAMP;
        if (data.id) {
            // UPDATE
            var _id = data.id;
            delete data.id;
            firebase.database().ref('/protected/' + destination + '/' + _id + "/").set(data).then(FB.onResolve(cb), FB.onReject(cb));
        } else {
            //ADD
            delete data.id; // in case its declared but undefined.
            firebase.database().ref('/protected/' + destination + '/').push(data).then(FB.onResolve(cb), FB.onReject(cb));
        }
    },
    log: function log(dest, data, cb) {
        var user = FireAuth.authenticatedUser();
        var ownerStr = "anonymous";
        Sanitizer.invoke(data);
        if (user && user.uid) {
            data.user_id = user.uid;
            ownerStr = user.email.replace(/\./g, "_");
            ownerStr = ownerStr.replace(new RegExp("#|$|[|]", 'g'), "_");
        } else if (data) {
            ownerStr = data.platform + " " + data.screen;
        }
        data.date = new Date().toString();
        data.updated_on = firebase.database.ServerValue.TIMESTAMP;
        firebase.database().ref('/logs/' + ownerStr + '/' + dest).push(data).then(FB.onResolve(cb), FB.onReject(cb));
    },
    deleteProtectedData: function deleteProtectedData(destination, uid, cb) {
        var path = '/protected/' + destination + '/' + uid + '/';
        firebase.database().ref(path).remove().then(FB.onResolve(cb), FB.onReject(cb));
    },
    uploadProtectedFile: function uploadProtectedFile($fileInput, destination, cb) {
        var file = $fileInput[0].files[0];
        var storageRef = firebase.storage().ref();
        var filePath = "/protected/" + destination + "/" + file.name;
        var fileStorageRef = storageRef.child(filePath);
        fileStorageRef.put(file).then(FB.onResolve(cb), FB.onReject(cb));
    },


    //-------PRIVATE
    readPrivateData: function readPrivateData(destination, cb) {
        var userId = firebase.auth().currentUser.uid;
        firebase.database().ref('/private/' + userId + "/" + destination).once('value').then(FB.onResolve(cb), FB.onReject(cb));
    },
    writePrivateData: function writePrivateData(destination, data, cb) {
        var userId = firebase.auth().currentUser.uid;
        Sanitizer.invoke(data);
        data.updated_on = firebase.database.ServerValue.TIMESTAMP;
        if (data.id) {
            // UPDATE
            var _id = data.id;
            delete data.id;
            firebase.database().ref('/private/' + userId + "/" + destination + '/' + _id + "/").set(data).then(FB.onResolve(cb), FB.onReject(cb));
        } else {
            //ADD
            delete data.id; // in case its declared but undefined.
            firebase.database().ref('/private/' + userId + '/' + destination).push(data).then(FB.onResolve(cb), FB.onReject(cb));
        }
    },
    deletePrivateData: function deletePrivateData(destination, uid, cb) {
        var userId = firebase.auth().currentUser.uid;
        if (uid) {
            var path = '/private/' + userId + "/" + destination + '/' + uid;
            firebase.database().ref(path).remove().then(FB.onResolve(cb), FB.onReject(cb));
        }
    },
    deleteUserData: function deleteUserData(cb) {
        var userId = firebase.auth().currentUser.uid;
        var path = '/private/' + userId;
        firebase.database().ref(path).remove().then(FB.onResolve(cb), FB.onReject(cb));
    },
    uploadPrivateFile: function uploadPrivateFile($fileInput, destination, cb) {
        var file = $fileInput[0].files[0];
        var storageRef = firebase.storage().ref();
        var userId = firebase.auth().currentUser.uid;
        var todayStr = Formatter.singleDate(Dater.getNewDate(new Date(), 0));
        var filePath = "/private/" + userId + "/" + destination + "/" + todayStr + "/" + file.name;
        var fileStorageRef = storageRef.child(filePath);
        fileStorageRef.put(file).then(FB.onResolve(cb), FB.onReject(cb));
    },
    deletePrivateFile: function deletePrivateFile(filePath, cb, cbData) {
        var storageRef = firebase.storage().ref();
        var userStorageRef = storageRef.child(filePath);
        userStorageRef.delete().then(FB.onResolve(cb, cbData), FB.onReject(cb));
    },


    // GENERIC:
    downloadFile: function downloadFile(filePath, cb, cbData) {
        var storageRef = firebase.storage().ref();
        var userStorageRef = storageRef.child(filePath);
        userStorageRef.getDownloadURL().then(FB.onResolve(cb, cbData), FB.onReject(cb));
    },
    updateProfile: function updateProfile(data, cb) {
        var user = firebase.auth().currentUser;
        if (user) {
            user.updateProfile(data).then(function () {
                cb(true);
                FireAuth.profileUpdated();
            }, FB.onReject(cb));
        }
    },


    //STUFF FROM OTHER PROJECTS, REMOVE IF NOT USED:

    //-------PRIVATE
    readUserData: function readUserData(destination, cb) {
        var userId = firebase.auth().currentUser.uid;
        firebase.database().ref('/private/' + destination + "/" + userId).once('value').then(FB.onResolve(cb), FB.onReject(cb));
    },
    writeUserData: function writeUserData(destination, data, cb) {
        var userId = firebase.auth().currentUser.uid;
        Sanitizer.invoke(data);
        firebase.database().ref('/private/' + destination + '/' + userId).set(data).then(FB.onResolve(cb), FB.onReject(cb));
    },


    //-------PUBLIC
    writePublicData: function writePublicData(destination, data, cb) {
        firebase.database().ref('/public/' + destination + '/').push(data).then(FB.onResolve(cb), FB.onReject(cb));
    },
    uploadPublicFile: function uploadPublicFile($input, destination, cb) {
        var file = $input[0].files[0];
        var storageRef = firebase.storage().ref();
        var filePath = "/public/" + destination + "/" + file.name;
        var fileStorageRef = storageRef.child(filePath);
        fileStorageRef.put(file).then(function (snapshot) {
            cb($input, snapshot);
        }, FB.onReject(cb));
    },
    deleteFile: function deleteFile(filePath, cb, cbData) {
        var storageRef = firebase.storage().ref();
        var userStorageRef = storageRef.child(filePath);
        userStorageRef.delete().then(FB.onResolve(cb, cbData), FB.onReject(cb));
    }
};

module.exports = FB;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Looper = __webpack_require__(4);

var ST = {
    searchAndReplace: function searchAndReplace(str, find, replaceWith) {
        var re = new RegExp(find, 'g');
        return str.replace(re, replaceWith);
    },
    injectAround: function injectAround(str, find, beforeStr, afterStr) {
        var l = find.length;
        if (l > 0) {
            for (var i = 0; i < str.length; i++) {
                var chars = str.substring(i, i + l);
                if (chars.toLowerCase() === find.toLowerCase()) {
                    var newStr = beforeStr + chars + afterStr;
                    str = str.substring(0, i) + newStr + str.substring(i + l);
                    i = i + l + beforeStr.length + afterStr.length - 1;
                }
            }
        }
        return str;
    },
    parseHTMLString: function parseHTMLString(html, resObj) {
        _Looper.forEach(resObj, function (propName, propVal) {
            html = ST.searchAndReplace(html, "{{" + propName + "}}", propVal);
        });
        return html;
    }
};
module.exports = ST;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Loader = {
    script: function script(url, objName, cb) {
        var script = document.createElement("script");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", url);
        document.getElementsByTagName("head")[0].appendChild(script);

        var timeout = 100; // 5 seconds timeout
        var isLoaded = function isLoaded() {
            setTimeout(function () {
                timeout--;
                if (typeof window[objName] !== 'undefined') {
                    cb();
                } else if (timeout > 0) {
                    isLoaded();
                } else {
                    console.error(url + ", failed to load.");
                }
            }, 100);
        };
        isLoaded();
    }
};

module.exports = Loader;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _Looper = __webpack_require__(4);
var _HTML = __webpack_require__(14);
var _Misc = __webpack_require__(1);

var UIComponent = function () {
    function UIComponent(parentSel, HTML, addFirst, resource) {
        _classCallCheck(this, UIComponent);

        if (resource) this.resource = resource;
        this.id = _HTML.insert(parentSel, HTML, this.resource, addFirst);
        this.$self = $("#" + this.id, parentSel);
        if (this.$self.length === 0) this.$self = $("#" + this.id);
        if (this.$self.length === 0) this.$self = parentSel;
        this.$self.addClass("hidden");
        this.ready = false;
        this.initializedChildrenCount = 0;
        this.childrenCount = 0;
        this.children = [];
        _Misc.callLater(this.initialize.bind(this));
    }

    _createClass(UIComponent, [{
        key: "initialize",
        value: function initialize(showPending, requireInputHelper, requireFirebase, requireL2Modules, requireCharts) {
            this.showPending = showPending || false;
            this.requireInputHelper = requireInputHelper || false;
            this.requireFirebase = requireFirebase || false;
            this.requireL2Modules = requireL2Modules || false;
            this.requireCharts = requireCharts || false;

            if (this.requireFirebase || this.requireCharts) {
                this.hasExternalDependencies(); // Creation process paused
            } else {
                _Misc.callLater(this.createChildren.bind(this));
            }
        }
    }, {
        key: "createChildren",
        value: function createChildren(kids) {
            if (kids && kids.length > 0) {
                this.childrenCount = kids.length;
                this.children = kids;
                _Looper.array(kids, function (kid, idx) {
                    kid.onInitialized = function () {
                        this.initializedChildrenCount++;
                        this.preInitialized();
                    }.bind(this);
                }.bind(this));
            }
            _Misc.callLater(this.addEventListeners.bind(this));
        }
    }, {
        key: "addEventListeners",
        value: function addEventListeners() {
            _Misc.callLater(this.preInitialized.bind(this));
        }
    }, {
        key: "preInitialized",
        value: function preInitialized() {
            if (this.childrenCount > 0) {
                if (this.childrenCount > this.initializedChildrenCount) return; //CHILDREN NOT YET READY, NEED TO WAIT.
            }
            _Misc.callLater(this.initialized.bind(this));
        }
    }, {
        key: "initialized",
        value: function initialized() {
            this.ready = true;
            if (this.showPending) {
                this.show();
            }
            if (this.onInitialized) {
                this.onInitialized();
            }
            if (this.readyOnDOM) {
                this.readyOnDOM();
            }
        }
    }, {
        key: "show",


        // generic function:
        value: function show() {
            this.showPending = false;
            if (this.ready) {
                if (this.$self.hasClass("hidden")) {
                    this.$self.removeClass("hidden").addClass("animated quick fadeIn");
                    _Misc.callLater(function () {
                        this.readyOnScreen();
                        this.$self.removeClass("animated quick fadeIn");
                    }.bind(this), 250);
                    if (this.scrollTop) {
                        _Misc.scrollToTop();
                    }
                }
            } else {
                this.showPending = true;
            }
        }
    }, {
        key: "hide",
        value: function hide() {
            this.$self.addClass("hidden");
        }
    }, {
        key: "addChild",
        value: function addChild(html, wrapperSel, addFirst, resource, after) {
            wrapperSel = wrapperSel ? $(wrapperSel, this.$self) : this.$self;
            return _HTML.insert(wrapperSel, html, resource, addFirst, after);
        }
    }, {
        key: "pathChanged",
        value: function pathChanged(l1, l2, l3, l4, l5) {
            if (this.children) {
                _Looper.array(this.children, function (child) {
                    child.pathChanged(l1, l2, l3, l4, l5);
                });
            }
        }
    }, {
        key: "readyOnScreen",
        // called when URL changes
        value: function readyOnScreen() {/* called after show effect is done */}
    }, {
        key: "readyOnDOM",
        value: function readyOnDOM() {/* SHOULD ONLY BE USED BY ROUTER.*/}
    }, {
        key: "hasExternalDependencies",
        value: function hasExternalDependencies() {/* SHOULD ONLY BE USED BY ROUTER.*/}
    }]);

    return UIComponent;
}();

module.exports = UIComponent;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Dater = {
    getMondayDate: function getMondayDate(d) {
        if (!(d instanceof Date)) d = new Date(d);
        var day = d.getDay();
        var diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
        return new Date(d.setDate(diff));
    },
    getFirstDateOfMonth: function getFirstDateOfMonth(d) {
        if (!(d instanceof Date)) d = new Date(d);
        return new Date(d.getFullYear(), d.getMonth(), 1);
    },
    getDateOfNextMonth: function getDateOfNextMonth(d) {
        if (!(d instanceof Date)) d = new Date(d);
        return new Date(d.getFullYear(), d.getMonth() + 1, d.getDate());
    },
    getDateOfNextYear: function getDateOfNextYear(d) {
        if (!(d instanceof Date)) d = new Date(d);
        return new Date(d.getFullYear() + 1, d.getMonth(), d.getDate());
    },
    getFirstDateOfYear: function getFirstDateOfYear(d) {
        if (!(d instanceof Date)) d = new Date(d);
        return new Date(d.getFullYear(), 0, 1);
    },
    getTotalNumbersOfDaysInYear: function getTotalNumbersOfDaysInYear(d) {
        var year = d.getFullYear();
        var isLeap = this.isLeapYear(year);
        return isLeap ? 366 : 365;
    },
    isLeapYear: function isLeapYear(year) {
        return year % 400 === 0 || year % 100 !== 0 && year % 4 === 0;
    },
    getDaysInMonth: function getDaysInMonth(d) {
        var md = new Date(d.getFullYear(), d.getMonth() + 1, 0);
        return md.getDate();
    },
    getNextDayDate: function getNextDayDate(d) {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);
    },
    getNumberOfDaysBetweenTwoDates: function getNumberOfDaysBetweenTwoDates(startDate, endDate) {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var sTime = startDate.getTime();
        var eTime = endDate.getTime();
        var days = Math.abs(sTime - eTime) / oneDay;
        return Math.floor(days);
    },
    getNewDate: function getNewDate(d, delta) {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate() + (delta ? delta : 0));
    },
    isInRange: function isInRange(startDate, endDate, checkDate) {

        if (!startDate.getTime) startDate = new Date(parseInt(startDate));
        if (!endDate.getTime) endDate = new Date(parseInt(endDate));
        if (!checkDate.getTime) checkDate = new Date(parseInt(checkDate));
        var sdTime = startDate.getTime();
        var edTime = endDate.getTime();
        var cdTime = checkDate.getTime();
        var isInRange = cdTime >= sdTime && cdTime <= edTime;
        return isInRange;
    },
    getPrevDate: function getPrevDate(date) {
        if (!(date instanceof Date)) date = new Date(date);
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
    },
    getSMDate: function getSMDate(date) {
        if (!(date instanceof Date)) date = new Date(date);
        var dateDay = date.getDate();
        if (dateDay > 15) {
            // get next Month Date
            return new Date(date.getFullYear(), date.getMonth() + 1, 1);
        }
        return new Date(date.getFullYear(), date.getMonth(), 15);
    },
    getNextSMDate: function getNextSMDate(date) {
        if (!(date instanceof Date)) date = new Date(date);
        var dateDay = date.getDate();
        if (dateDay === 1) {
            // get next Month Date
            return new Date(date.getFullYear(), date.getMonth(), 15);
        }
        return new Date(date.getFullYear(), date.getMonth() + 1, 1);
    },
    getTodayTime: function getTodayTime() {
        var d = new Date();
        var todayDate = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        return todayDate.getTime();
    },
    getNowTime: function getNowTime() {
        var d = new Date();
        return d.getTime();
    },
    getStartOfDayTime: function getStartOfDayTime(date) {
        if (!(date instanceof Date)) date = new Date(date);
        var d = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
        return d.getTime();
    },


    /*  "d"  : "every day",
        "w"  : "every week",
        "bw" : "every other week",
        "sm" : "on 1st and 15th",
        "m"  : "monthly",
        "y"  : "yearly"*/
    getNextIntervalTime: function getNextIntervalTime(date, interval) {
        var d = new Date(date);
        switch (interval) {
            case "d":
                d = Dater.getNextDayDate(d);break;
            case "w":
                d = Dater.getNewDate(d, 7);break;
            case "bw":
                d = Dater.getNewDate(d, 14);break;
            case "sm":
                d = Dater.getNextSMDate(d);break;
            case "m":
                d = Dater.getDateOfNextMonth(d);break;
            case "y":
                d = Dater.getDateOfNextYear(d);break;
        }
        d.setHours(0, 0, 0, 0);
        return d.getTime();
    }
};

module.exports = Dater;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Event = __webpack_require__(2);
var Misc = __webpack_require__(1);

var FireAuth = {
    init: function init() {
        firebase.auth().onAuthStateChanged(function (user) {
            if (user) {
                // User is signed in.
                //console.log("user is in");
            } else {
                    // No user is signed in.
                    //console.log("NO USER");
                }
            FireAuth.profileUpdated();
        });
    },

    addUserWatcher: function addUserWatcher(cb) {
        if (!FireAuth.userWatchers) FireAuth.userWatchers = [];
        FireAuth.userWatchers.push(cb);
        if (window.firebase) {
            // firebase was initialized and this can be called.
            try {
                cb(FireAuth.authenticatedUser());
            } catch (e) {
                console.error(e);
            }
        }
    },

    profileUpdated: function profileUpdated() {
        var n = FireAuth.userWatchers ? FireAuth.userWatchers.length : 0;
        for (var i = 0; i < n; i++) {
            var cb = FireAuth.userWatchers[i];
            cb(FireAuth.authenticatedUser());
        }
    },
    reAuth: function reAuth(pass, cb) {
        var user = FireAuth.authenticatedUser();
        if (user) {
            var credential = firebase.auth.EmailAuthProvider.credential(user.email, pass);
            user.reauthenticateWithCredential(credential).then(function (val) {
                cb(val);
            }).catch(function (error) {
                cb(error);
            });
        }
    },
    reAuthWithPopup: function reAuthWithPopup(cb) {
        var user = FireAuth.authenticatedUser();
        if (user) {
            var providerData = user.providerData[0];
            var providerId = providerData.providerId;
            var provider = null;
            console.log(providerId);
            if (providerId === 'google.com') {
                provider = new firebase.auth.GoogleAuthProvider();
            }
            if (provider) {
                user.reauthenticateWithPopup(provider).then(function (val) {
                    cb(val);
                }).catch(function (error) {
                    cb(error);
                });
            }
        }
    },
    deleteUser: function deleteUser(cb) {
        var user = FireAuth.authenticatedUser();
        if (user) {
            user.delete().then(function (val) {
                cb(val);
            }).catch(function (error) {
                cb(error);
            });
        }
    },
    updatePassword: function updatePassword(newPass, cb) {
        var user = FireAuth.authenticatedUser();
        if (user) {
            user.updatePassword(newPass).then(function (val) {
                cb(val);
            }).catch(function (error) {
                cb(error);
            });
        }
    },


    authenticatedUser: function authenticatedUser() {
        return window.firebase && firebase.auth() ? firebase.auth().currentUser : null;
    },

    signIn: function signIn(email, password, cb) {
        firebase.auth().signInWithEmailAndPassword(email, password).then(function (val) {
            cb(true);
        }).catch(function (error) {
            console.log(error);
            cb(error.message);
        });
    },

    resetPass: function resetPass(email, cb) {
        var auth = firebase.auth();
        auth.sendPasswordResetEmail(email).then(function () {
            cb();
        }).catch(function (error) {
            cb(error);
        });
    },

    signUpWithEmailPassword: function signUpWithEmailPassword(email, pass, cb) {
        firebase.auth().createUserWithEmailAndPassword(email, pass).then(function (val) {
            cb(true);
        }).catch(function (error) {
            console.log(error);
            cb(error.message);
        });
    },


    signOut: function signOut(cb) {
        firebase.auth().signOut().then(function () {
            // Sign-out successful.
            if (cb) cb(true);
        }).catch(function (error) {
            // An error happened.
            if (cb) cb(error.message);
        });
    },

    authGoogle: function authGoogle(cb) {
        var provider = new firebase.auth.GoogleAuthProvider();
        FireAuth.signInWithProvider(provider, function (response) {
            cb(response);
        });
    },

    authFacebook: function authFacebook(cb) {
        var provider = new firebase.auth.FacebookAuthProvider();
        FireAuth.signInWithProvider(provider, function (response) {
            cb(response);
        });
    },


    signInWithProvider: function signInWithProvider(provider, cb) {
        firebase.auth().signInWithPopup(provider).then(function (result) {
            cb(true);
        }).catch(function (error) {
            var errorMessage = error.message;
            cb(errorMessage);
        });
    }

};

module.exports = FireAuth;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ENUM = {
    KEY: {
        CHANGED: "_changed",
        CATS: "categories",
        USER_CATEGORIES: "user-categories"
    },
    VIEWS: {
        APP: "app",
        IN: "in",
        DEFAULT: "welcome",
        LOGIN: "log-in",
        LOGOUT: "sign-out",
        REGISTER: "sign-up",
        CONTACT_US: "contact-us",
        TERMS: "terms-of-service",

        //APP MODULES:
        OVERSEER: "overseer",
        OVERVIEW: "overview",
        SETTING: "account",

        //IN MODULES:
        CONTACT: "contact",
        DASHBOARD: "dashboard",
        MY_ACCOUNT: "my-account",
        BUDGET: "budget",
        TOOL: "tools",
        TRACKER: "tracker",
        REPORTS: "reports",

        isValid: function isValid(value) {
            for (var propName in ENUM.VIEWS) {
                var propVal = this[propName];
                if (propVal === value) {
                    return true;
                }
            }
            return false;
        },

        getModuleName: function getModuleName(l1Path) {
            var name = ENUM.VIEWS.DEFAULT; // default page when path is not found
            if (ENUM.VIEWS.isValid(l1Path)) name = l1Path;
            //use this switch to override any value. eg, to set the same module for different paths.
            switch (l1Path) {}
            return name;
        },

        isInModule: function isInModule(l1Name) {
            var yesItIs = false;
            switch (l1Name) {
                case ENUM.VIEWS.CONTACT:
                case ENUM.VIEWS.DASHBOARD:
                case ENUM.VIEWS.MY_ACCOUNT:
                case ENUM.VIEWS.BUDGET:
                case ENUM.VIEWS.TOOL:
                case ENUM.VIEWS.REPORTS:
                    yesItIs = true;break;
            }
            return yesItIs;
        }
    }
};

module.exports = ENUM;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ID = __webpack_require__(20);
var _StringTools = __webpack_require__(8);

var Html = {
    insert: function insert(parentSel, html, resource, addFirst, after) {
        var _id = _ID.getID();
        if (!resource) resource = {};
        if (!resource._UID_) resource._UID_ = _id;
        html = _StringTools.parseHTMLString(html, resource);
        if (after) $(parentSel).after(html);else if (addFirst) $(parentSel).prepend(html);else $(parentSel).append(html);
        return resource._UID_;
    }
};
module.exports = Html;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fontastic/fonts/ieo.eot";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//scss:
__webpack_require__(55);

//import registerServiceWorker from 'core/registerServiceWorker';

//BASE
var _app = __webpack_require__(36);

//ENUM:
var ENUM = __webpack_require__(13);

//UTILS:
var Loader = __webpack_require__(9);
var Firebase = __webpack_require__(7);

_app.init = function () {
    _app.addedFlag = false;
    _app.removedFlag = false;

    //registerServiceWorker();
    //check Browser support:

    if (_app.supported()) {
        Loader.script("/vendor/jquery-3.2.1.slim.min.js", "$", function () {
            if (Firebase.initialized) {
                _app.appReady();
            }
        });
        Firebase.invoke(function () {
            if (typeof jQuery != 'undefined') {
                _app.appReady();
            }
        });
    }
};

_app.appReady = function () {
    _app.router = __webpack_require__(40);
    _app.router.initialize();
    _app.router.addPathWatcher(_app.pathChanged);
    //ADS:
    adsbygoogle = window.adsbygoogle || [];
};

_app.supported = function () {
    var supported = true;
    //if (typeof(Worker) === "undefined")
    //   supported = false;
    if (!window.history || !history.pushState) supported = false;
    return supported;
};

_app.pathChanged = function (l1, l2, l3) {
    var isApp = l1 === ENUM.VIEWS.APP || l1 === ENUM.VIEWS.IN;
    if (isApp && !_app.addedFlag) {
        $(".indexed").addClass("app-state");
        _app.addedFlag = true;
        _app.removedFlag = false;
    } else if (!isApp && !_app.removedFlag) {
        $(".indexed").removeClass("app-state");
        _app.addedFlag = false;
        _app.removedFlag = true;
    }
};

_app.init();

//guest@ieo.com
//test123

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Misc = __webpack_require__(1);
var _Event = __webpack_require__(2);

var _History = {
    init: function init() {
        _History.supported = window.history && history.pushState;
        if (_History.supported) {
            _History.currentLocation = _History.getLocation();
            _Misc.callEvery(_History.checkHistory, 500);
            _Event.tap("a", _History.onATap);
            _History.updatePaths();
        }
    },

    onATap: function onATap(e) {
        var $a = $(e.currentTarget);
        var newPath = $a.attr("href");if (newPath && newPath.indexOf("www") < 0 && newPath && newPath.indexOf("http") < 0 && newPath.indexOf("mailto") < 0) {
            e.preventDefault();
            _History.pushState(newPath);
        }
    },

    pushState: function pushState(newUrl) {
        if (_History.getLocation() !== newUrl) {
            history.pushState(null, null, newUrl);
        }
    },

    forceState: function forceState(newUrl) {
        if (_History.getLocation() !== newUrl) {
            history.replaceState(null, null, newUrl);
        }
    },

    checkHistory: function checkHistory() {
        if (_History.currentLocation !== _History.getLocation()) {
            _History.currentLocation = _History.getLocation();
            _History.updatePaths();
            _History.historyChangedHandler();
        }
    },

    historyChangedHandler: function historyChangedHandler() {
        //console.log("History has changed to: " + _History.getLocation());
    },

    updatePaths: function updatePaths() {
        _History.l1 = _History.getLevelPath(0).toLowerCase();
        _History.l2 = _History.getLevelPath(1).toLowerCase();
        _History.l3 = _History.getLevelPath(2).toLowerCase();
        _History.l4 = _History.getLevelPath(3).toLowerCase();
        _History.l5 = _History.getLevelPath(4).toLowerCase();
        if (_History.pathCBs) {
            var n = _History.pathCBs.length;
            for (var i = 0; i < n; i++) {
                _History.pathCBs[i](_History.l1, _History.l2, _History.l3, _History.l4, _History.l5);
            }
        }
    },

    getPaths: function getPaths() {
        var pathnames = window.location.pathname.toLowerCase();
        if (pathnames.charAt(0) === "/") pathnames = pathnames.slice(1);
        return pathnames.split('/');
    },

    getLocation: function getLocation() {
        var loc = window.location.pathname.toLowerCase();
        if (loc.charAt(0) === "/") loc = loc.slice(1);
        return loc;
    },

    getLevelPath: function getLevelPath(level) {
        var path = _History.getPaths()[level];
        if (path) return path.toLowerCase();
        return "";
    },

    addPathWatcher: function addPathWatcher(cb) {
        if (!_History.pathCBs) _History.pathCBs = [];
        _History.pathCBs.push(cb);
    },

    pushPrev: function pushPrev(altUrl) {
        if (this.prevDest) {
            window.location.href = this.prevDest;
        } else {
            this.pushState(altUrl);
        }
    }
};

module.exports = _History;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sort = {
    string: function string(list, propName, reverse) {
        list.sort(function (itemA, itemB) {
            var strA = itemA && itemA[propName] ? itemA[propName] : "";
            var strB = itemB && itemB[propName] ? itemB[propName] : "";
            if (strA === "") return 1;
            if (strB === "") return -1;
            if (strA.toLowerCase() < strB.toLowerCase()) return -1;
            if (strA.toLowerCase() > strB.toLowerCase()) return 1;
            return 0;
        });
        if (reverse) list.reverse();
    },
    number: function number(list, propName, reverse) {
        list.sort(function (itemA, itemB) {
            var numA = itemA && itemA[propName] ? itemA[propName] : 0;
            var numB = itemB && itemB[propName] ? itemB[propName] : 0;
            if (numA === 0) return 1;
            if (numB === 0) return -1;
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
        });
        if (reverse) list.reverse();
    },
    date: function date(list, reverse) {
        list.sort(function (itemA, itemB) {
            var dateA = itemA ? parseInt(itemA.date) : 0;
            var dateB = itemB ? parseInt(itemB.date) : 0;
            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;
            var numA = itemA && itemA.updated_on ? itemA.updated_on : 0;
            var numB = itemB && itemB.updated_on ? itemB.updated_on : 0;
            if (numA === 0) return 1;
            if (numB === 0) return -1;
            if (numA < numB) return -1;
            if (numA > numB) return 1;
            return 0;
        });
        if (reverse) list.reverse();
    },
    notes: function notes(list, reverse) {
        this.string(list, "notes", reverse);
    },
    hasAttachment: function hasAttachment(list, reverse) {
        this.string(list, "attachmentCls", reverse);
    },
    isRecurring: function isRecurring(list, reverse) {
        this.string(list, "recurringCls", reverse);
    },
    amount: function amount(list, reverse) {
        this.number(list, "amount", reverse);
    },
    updated_on: function updated_on(list, reverse) {
        this.number(list, "updated_on", reverse);
    },
    type_tag: function type_tag(list, reverse) {
        this.string(list, "typeName", reverse);
    },
    tag_type: function tag_type(list, reverse) {
        this.string(list, "tagStr", reverse);
    },
    name: function name(list, reverse) {
        this.string(list, "name", reverse);
    }
};

module.exports = Sort;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Charts;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _Loader = __webpack_require__(9);
var _Misc = __webpack_require__(1);
var _Formatter = __webpack_require__(5);
var _Looper = __webpack_require__(4);
var _Html = __webpack_require__(14);

var Charts = (_Charts = {
    invoke: function invoke(cb) {
        if (Charts.busy) return;
        Charts.busy = true;
        _Loader.script("/vendor/Chart.min.js", "Chart", function () {
            Charts.initComplete();
            Charts.busy = false;
            cb();
        });
    },
    initComplete: function initComplete() {
        Charts.initialized = true;
    },
    generateColors: function generateColors() {
        var bgs = [];
        var bs = [];
        for (var i = 0; i < 100; i++) {
            var c1 = _Misc.randomNumber(0, 255);
            var c2 = _Misc.randomNumber(0, 255);
            var c3 = _Misc.randomNumber(0, 255);
            bgs.push("rgba(" + c1 + "," + c2 + "," + c3 + ", 0.4)");
            bs.push("rgba(" + c1 + "," + c2 + "," + c3 + ", 1)");
        }
        Charts.colors = {
            backgroundColor: bgs,
            borderColor: bs
        };
    },
    trackerSummaryChart: function trackerSummaryChart(chartData) {
        var $elm = chartData.$div;
        $elm.empty().append("<canvas></canvas>");
        Charts.generateColors();
        var $c = $("canvas", $elm);

        var isStacked = chartData.labels.length > 10;

        return new Chart($c, {
            type: 'bar',
            data: {
                labels: chartData.labels,
                datasets: [{
                    label: "Income",
                    data: chartData.incomes,
                    backgroundColor: _Misc.shadeColor("#4caf50", 0.3),
                    borderColor: _Misc.shadeColor("#4caf50", 1),
                    borderWidth: 1

                }, {
                    label: "Expenses",
                    data: chartData.expenses,
                    backgroundColor: _Misc.shadeColor("#ef9000", 0.3),
                    borderColor: _Misc.shadeColor("#ef9000", 1),
                    borderWidth: 1
                }, {
                    label: "Allocations",
                    data: chartData.allocations,
                    backgroundColor: _Misc.shadeColor("#4F84C4", 0.3),
                    borderColor: _Misc.shadeColor("#4F84C4", 1),
                    borderWidth: 1
                }]
            },
            options: {
                legend: {
                    display: false
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var lb = dataset.label;
                            var currentValue = dataset.data[tooltipItem.index];
                            if (currentValue === 0) return null;
                            return " " + lb + ": " + _Formatter.money(currentValue, true);
                        }
                    }
                },
                responsive: true,
                scales: {
                    xAxes: [{
                        stacked: isStacked
                    }],
                    yAxes: [{
                        stacked: isStacked,
                        ticks: {
                            beginAtZero: true,
                            callback: function callback(value, index, values) {
                                if (value < 0) return "-" + _Formatter.shortMoney(value);
                                return _Formatter.shortMoney(value);
                            }
                        }
                    }]
                }
            }
        });
    },


    /*
        var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var color = Chart.helpers.color;
    var horizontalBarChartData = {
        labels: ["January", "February", "March", "April", "May", "June", "July"],
        datasets: [{
            label: 'Dataset 1',
            backgroundColor: color(window.chartColors.red).alpha(0.5).rgbString(),
            borderColor: window.chartColors.red,
            borderWidth: 1,
            data: [
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor()
            ]
        }, {
            label: 'Dataset 2',
            backgroundColor: color(window.chartColors.blue).alpha(0.5).rgbString(),
            borderColor: window.chartColors.blue,
            data: [
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor(),
                randomScalingFactor()
            ]
        }]
    
    };
    
    window.onload = function() {
        var ctx = document.getElementById("canvas").getContext("2d");
        window.myHorizontalBar = new Chart(ctx, {
            type: 'horizontalBar',
            data: horizontalBarChartData,
            options: {
                // Elements options apply to all of the options unless overridden in a dataset
                // In this case, we are setting the border of each horizontal bar to be 2px wide
                elements: {
                    rectangle: {
                        borderWidth: 2,
                    }
                },
                responsive: true,
                legend: {
                    position: 'right',
                },
                title: {
                    display: true,
                    text: 'Chart.js Horizontal Bar Chart'
                }
            }
        });
    
    };*/

    dashboardHabitChart: function dashboardHabitChart(chartData) {
        var $elm = chartData.$div;
        $elm.empty().append("<canvas></canvas>");
        Charts.generateColors();
        var $c = $("canvas", $elm);

        var lbsCount = chartData.labels.length;
        var isStacked = chartData.labels.length > 10;

        return new Chart($c, {
            type: 'horizontalBar',
            data: {
                labels: chartData.labels,
                datasets: [{
                    label: "Income",
                    data: chartData.incomes,
                    backgroundColor: _Misc.shadeColor("#4caf50", 0.3),
                    borderColor: _Misc.shadeColor("#4caf50", 1),
                    borderWidth: 1

                }, {
                    label: "Expenses",
                    data: chartData.expenses,
                    backgroundColor: _Misc.shadeColor("#ef9000", 0.3),
                    borderColor: _Misc.shadeColor("#ef9000", 1),
                    borderWidth: 1
                }, {
                    label: "Allocations",
                    data: chartData.allocations,
                    backgroundColor: _Misc.shadeColor("#4F84C4", 0.3),
                    borderColor: _Misc.shadeColor("#4F84C4", 1),
                    borderWidth: 1
                }]
            },
            options: {
                legend: {
                    display: false
                },
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var lb = dataset.label;
                            var currentValue = dataset.data[tooltipItem.index];
                            if (currentValue === 0) return null;
                            return " " + lb + ": " + _Formatter.money(currentValue, true);
                        }
                    }
                },
                responsive: true,
                scales: {
                    xAxes: [{
                        stacked: isStacked,
                        ticks: {
                            beginAtZero: false,
                            callback: function callback(value, index, values) {
                                return _Formatter.shortMoney(value);
                            }
                        }
                    }],
                    yAxes: [{
                        stacked: isStacked,
                        ticks: {
                            beginAtZero: true,
                            callback: function callback(value, index, values) {

                                var lbH = lbsCount * 18;
                                var ch = $c.height();
                                if (lbH > ch) {
                                    if (lbsCount / 4 * 18 > ch) {
                                        if (index % 5 == 0) return value;
                                    } else if (lbsCount / 3 * 18 > ch) {
                                        if (index % 4 == 0) return value;
                                    } else if (lbsCount / 2 * 18 > ch) {
                                        if (index % 3 == 0) return value;
                                    } else if (index % 2 == 0) {
                                        return value;
                                    }
                                    return "";
                                }
                                return value;
                            }
                        }
                    }]
                }
            }
        });
    },
    dashGoalChart: function dashGoalChart(chartData) {
        var $elm = chartData.$div;
        $elm.empty().append("<canvas></canvas>");
        var $c = $("canvas", $elm);
        var chart = new Chart($c, {
            type: "polarArea",
            data: {
                labels: chartData.labels,
                datasets: [{
                    data: chartData.percentages,
                    backgroundColor: chartData.bgs,
                    borderColor: chartData.bcs,
                    borderWidth: 1

                }]
            },
            options: {
                responsive: false,
                title: {
                    display: true,
                    text: chartData.title,
                    padding: 15,
                    fontStyle: "normal"
                },
                tooltips: {
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var lb = data.labels[tooltipItem.index];
                            var currentValue = dataset.data[tooltipItem.index];
                            if (currentValue === 0) return null;
                            return " " + lb + ": " + _Formatter.percentage(currentValue);
                        }
                    }
                },
                legend: false,
                scale: {
                    ticks: {
                        beginAtZero: true,
                        callback: function callback(value, index, values) {
                            return value + "%";
                            //return _Formatter.shortMoney(value);
                        }
                    },
                    reverse: false
                },
                animation: {
                    animateRotate: false,
                    animateScale: true
                }
            }
        });
        return chart;
    },


    /*    var randomScalingFactor = function() {
            return Math.round(Math.random() * 100);
        };
    
    var chartColors = window.chartColors;
    var color = Chart.helpers.color;
    var config = {
        data: {
            datasets: [{
                data: [
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                    randomScalingFactor(),
                ],
                backgroundColor: [
                    color(chartColors.red).alpha(0.5).rgbString(),
                    color(chartColors.orange).alpha(0.5).rgbString(),
                    color(chartColors.yellow).alpha(0.5).rgbString(),
                    color(chartColors.green).alpha(0.5).rgbString(),
                    color(chartColors.blue).alpha(0.5).rgbString(),
                ],
                label: 'My dataset' // for legend
            }],
            labels: [
                "Red",
                "Orange",
                "Yellow",
                "Green",
                "Blue"
            ]
        },
        options: {
            responsive: true,
            legend: {
                position: 'right',
            },
            title: {
                display: true,
                text: 'Chart.js Polar Area Chart'
            },
            scale: {
                ticks: {
                    beginAtZero: true
                },
                reverse: false
            },
            animation: {
                animateRotate: false,
                animateScale: true
            }
        }
    };
    
    window.onload = function() {
        var ctx = document.getElementById("chart-area");
        window.myPolarArea = Chart.PolarArea(ctx, config);
    };
    
    document.getElementById('randomizeData').addEventListener('click', function() {
        config.data.datasets.forEach(function(piece, i) {
            piece.data.forEach(function(value, j) {
                config.data.datasets[i].data[j] = randomScalingFactor();
            });
        });
        window.myPolarArea.update();
    });
    
    var colorNames = Object.keys(window.chartColors);
    document.getElementById('addData').addEventListener('click', function() {
        if (config.data.datasets.length > 0) {
            config.data.labels.push('data #' + config.data.labels.length);
            config.data.datasets.forEach(function(dataset) {
                var colorName = colorNames[config.data.labels.length % colorNames.length];
                dataset.backgroundColor.push(window.chartColors[colorName]);
                dataset.data.push(randomScalingFactor());
            });
            window.myPolarArea.update();
        }
    });
    document.getElementById('removeData').addEventListener('click', function() {
        config.data.labels.pop(); // remove the label first
        config.data.datasets.forEach(function(dataset) {
            dataset.backgroundColor.pop();
            dataset.data.pop();
        });
        window.myPolarArea.update();
    });*/

    createLegendItems: function createLegendItems($legendWrapper, labels, dp, html) {
        var items = [];
        _Looper.array(labels, function (item, idx) {
            var brc = Charts.colors.borderColor[idx];
            var bgc = Charts.colors.backgroundColor[idx];
            var amount = _Formatter.money(dp[idx]);
            items.push({ label: item, brc: brc, bgc: bgc, amount: amount, sortOn: dp[idx] });
        });
        _Misc.sort(items, "sortOn");
        _Looper.array(items, function (item, idx) {
            if (idx > 6) return;
            _Html.insert($legendWrapper, html, item);
        });
    },
    snapPieChart: function snapPieChart($elm, labels, dp, legendHtml) {
        $elm.empty().append("<canvas></canvas>");
        var $c = $("canvas", $elm);
        var $l = $(".legend", $elm.parent()).empty();
        Charts.generateColors();
        if (legendHtml) Charts.createLegendItems($l, labels, dp, legendHtml);

        return new Chart($c, {
            type: 'doughnut',
            data: {
                datasets: [{
                    data: dp,
                    backgroundColor: Charts.colors.backgroundColor,
                    borderColor: Charts.colors.borderColor,
                    borderWidth: 1
                }],
                labels: labels
            },
            options: {
                responsive: false,
                legend: {
                    display: false
                },

                tooltips: {
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var lb = data.labels[tooltipItem.index];
                            var currentValue = dataset.data[tooltipItem.index];
                            return " " + lb + ": " + _Formatter.money(currentValue);
                        }
                    }
                }
            }
        });
    },
    pieChart: function pieChart($elm, dp, labels, bgCols, brCols, hideTooltip) {
        $elm.empty().append("<canvas></canvas>");
        if (!bgCols) {
            Charts.generateColors();
        } else {
            Charts.colors = {
                backgroundColor: bgCols,
                borderColor: brCols
            };
        }
        return new Chart($("canvas", $elm), {
            type: 'doughnut',
            data: {
                datasets: [{
                    data: dp,
                    backgroundColor: Charts.colors.backgroundColor,
                    borderColor: Charts.colors.borderColor,
                    borderWidth: 1
                }],
                labels: labels
            },
            options: {
                responsive: false,
                legend: {
                    display: false
                },

                tooltips: {
                    enabled: !hideTooltip,
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var lb = data.labels[tooltipItem.index];
                            var currentValue = dataset.data[tooltipItem.index];
                            return " " + lb + ": " + _Formatter.money(currentValue);
                        }
                    }
                }
            }
        });
    },
    budgetLineChart: function budgetLineChart($elm, dp, xLb, bgCols, brCols) {
        $elm.empty().append("<canvas></canvas>");
        Charts.colors = {
            backgroundColor: bgCols,
            borderColor: brCols
        };
        return new Chart($("canvas", $elm), {
            type: 'bar',
            data: {
                datasets: [{
                    data: dp,
                    backgroundColor: Charts.colors.backgroundColor,
                    borderColor: Charts.colors.borderColor,
                    borderWidth: 1
                }],
                labels: xLb
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            callback: function callback(value, index, values) {
                                return "";
                            }
                        }
                    }]
                },
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },

                tooltips: {
                    enabled: false
                }
            }
        });
    }
}, _defineProperty(_Charts, "budgetLineChart", function budgetLineChart($elm, dp, xLb, bgCols, brCols) {
    $elm.empty().append("<canvas></canvas>");
    Charts.colors = {
        backgroundColor: bgCols,
        borderColor: brCols
    };
    return new Chart($("canvas", $elm), {
        type: 'bar',
        data: {
            datasets: [{
                data: dp,
                backgroundColor: Charts.colors.backgroundColor,
                borderColor: Charts.colors.borderColor,
                borderWidth: 1
            }],
            labels: xLb
        },
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        callback: function callback(value, index, values) {
                            return "";
                        }
                    }
                }]
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false
            },

            tooltips: {
                enabled: false
            }
        }
    });
}), _defineProperty(_Charts, "barChart", function barChart($elm, dp) {
    var normativeData = [{ x: "8:00", y: 50 }, { x: "20:00", y: 50 }]; //horizontal const line
    var productivityData = [40, 41, 45, 50, 55, 60];
    var xDp = [{ x: 0, y: 10 }, { x: 0, y: 1 }, { x: 1, y: 6 }, { x: 4, y: 2 }];

    var myChart = new Chart($elm, {
        type: 'bar',
        data: {
            labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
            datasets: [{
                label: '# of Votes',
                data: dp,
                borderWidth: 1
            }]
        },
        options: {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            },
            legend: {
                display: true,
                labels: {
                    fontColor: 'rgb(0, 0, 0)'
                }
            }
        }
    });
}), _defineProperty(_Charts, "trackerChart", function trackerChart($elm, lbs, expenseDS, incomeDS) {
    var $c = $("canvas", $elm.empty().append("<canvas></canvas>"));
    var n = lbs.length;
    var modVal = 1;
    var smallScreen = $elm.width() < 400;
    if (n > 10) modVal = parseInt(n / 10);else if (n > 20) modVal = parseInt(n / 7);
    var horizontalBarChartData = {
        labels: lbs,
        datasets: [expenseDS, incomeDS]
    };
    var myHorizontalBar = new Chart($c, {
        type: 'horizontalBar',
        data: horizontalBarChartData,
        options: {
            onClick: function onClick(e, i) {
                console.log("ON CLICK IN CHART");
                console.log(e);
                e = i[0];
                console.log(e._index);
                var x_value = this.data.labels[e._index];
                var y_value = this.data.datasets[0].data[e._index];
                console.log(x_value);
                console.log(y_value);
            },
            tooltips: {
                callbacks: {
                    label: function label(tooltipItem, data) {
                        if (parseInt(tooltipItem.xLabel) < 0) return "-$" + Math.abs(parseInt(tooltipItem.xLabel));
                        return "$" + tooltipItem.xLabel;
                    }
                }
            },
            scales: {
                yAxes: [{
                    display: !smallScreen,
                    ticks: {
                        beginAtZero: true,
                        callback: function callback(value, index, values) {
                            if (index % modVal == 0) return value;
                            return "";
                        }
                    }
                }],
                xAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: function callback(value, index, values) {
                            if (parseInt(value) < 0) return "-$" + Math.abs(parseInt(value));
                            return '$' + value;
                        }
                    }
                }]
            },
            legend: {
                display: false
            }
        }
    });
    return myHorizontalBar;
}), _defineProperty(_Charts, "trackerChart12", function trackerChart12($elm, expenses, income) {
    $elm.empty();
    var lbs = expenses.concat(income);
    return new Chart($elm, {
        type: 'horizontalBar',
        data: {
            labels: lbs,
            datasets: [{
                data: expenses,
                borderWidth: 1,
                backgroundColor: "rgba(239, 144, 0, 0.5)",
                borderColor: "rgba(239, 144, 0, 1)",
                reverse: true
            }, {
                data: income,
                borderWidth: 1,
                backgroundColor: "rgba(0, 128, 0, 0.5)",
                borderColor: "rgba(0, 128, 0, 1)",
                reverse: true
            }]
        },
        options: {
            tooltips: {
                callbacks: {
                    label: function label(tooltipItem, data) {
                        return "$" + tooltipItem.xLabel;
                    }
                }
            },
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: function callback(value, index, values) {
                            console.log(value);
                            if (value) {
                                var y = value.y;
                                return value.y;
                            }
                        }
                    }
                }],
                xAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: function callback(value, index, values) {
                            if (value > 0) return "-$" + Math.abs(value);
                            return '$' + value;
                        }
                    }
                }]
            },
            legend: {
                display: false
            }
        }
    });
}), _defineProperty(_Charts, "snapChart", function snapChart($elm, chartData, colNums, isIncome) {
    $elm.empty();
    return new Chart($elm, {
        type: 'horizontalBar',
        data: {
            labels: chartData,
            datasets: [{
                data: chartData,
                borderWidth: 1,
                backgroundColor: "rgba(" + colNums + ", 0.5)",
                borderColor: "rgba(" + colNums + ", 1)",
                reverse: true
            }]
        },
        options: {
            tooltips: {
                callbacks: {
                    label: function label(tooltipItem, data) {
                        return "$" + tooltipItem.xLabel;
                    }
                }
            },
            scales: {
                yAxes: [{
                    position: isIncome ? "right" : "left",
                    ticks: {
                        beginAtZero: true,
                        callback: function callback(value, index, values) {
                            console.log(value);
                            var y = value.y;
                            return value;
                        }
                    }
                }],
                xAxes: [{
                    ticks: {
                        reverse: isIncome ? true : false,
                        beginAtZero: true,
                        callback: function callback(value, index, values) {
                            return '$' + value;
                        }
                    }
                }]
            },
            legend: {
                display: false
            }
        }
    });
}), _Charts);

module.exports = Charts;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Id = {
    ids: function ids() {
        if (!Id._ids) Id._ids = {};
        return Id._ids;
    },

    getID: function getID() {
        var newId = Id.UID();
        if (Id.ids[newId] == undefined) {
            Id.ids[newId] = newId;
            return newId;
        }
        return Id.getID();
    },

    s4: function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    },

    UID: function UID() {
        return "UID_" + Id.s4() + Id.s4();
    }
};

module.exports = Id;

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _App = {
    init: function init(readyCB) {
        if (window.addEventListener) {
            window.addEventListener('load', readyCB);
        } else {
            window.attachEvent('onload', readyCB);
        }
    }
};

module.exports = _App;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Misc = __webpack_require__(1);

var Ensure = {
    load: function load(ensureFunction, cb) {
        if (Ensure.hasOwnProperty(ensureFunction)) {
            Ensure[ensureFunction](cb);
        }
    },
    loadComplete: function loadComplete(module, cb) {
        cb(module);
    },
    welcome: function welcome(cb) {
        __webpack_require__.e/* require.ensure */(6).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(35);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    "sign-up": function signUp(cb) {
        __webpack_require__.e/* require.ensure */(11).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(33);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    "sign-out": function signOut(cb) {
        __webpack_require__.e/* require.ensure */(12).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(31);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    "log-in": function logIn(cb) {
        __webpack_require__.e/* require.ensure */(13).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(30);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    "contact-us": function contactUs(cb) {
        __webpack_require__.e/* require.ensure */(9).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(29);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },

    overseer: function overseer(cb) {
        __webpack_require__.e/* require.ensure */(7).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(32);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },

    "terms-of-service": function termsOfService(cb) {
        __webpack_require__.e/* require.ensure */(8).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(34);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    /*app : function(cb){
        require.ensure(["view/app/App"], function(){
            let module = require("view/app/App");
            Ensure.loadComplete(module, cb);
        });
    },*/

    //IN L2 Modules:
    in: function _in(cb) {
        __webpack_require__.e/* require.ensure */(5).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(21);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },

    "my-account": function myAccount(cb) {
        __webpack_require__.e/* require.ensure */(14).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(22);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },

    dashboard: function dashboard(cb) {
        __webpack_require__.e/* require.ensure */(3).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(25);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },

    reports: function reports(cb) {
        __webpack_require__.e/* require.ensure */(2).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(26);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },

    tracker: function tracker(cb) {
        __webpack_require__.e/* require.ensure */(0).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(28);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },

    budget: function budget(cb) {
        __webpack_require__.e/* require.ensure */(1).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(23);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },

    tools: function tools(cb) {
        __webpack_require__.e/* require.ensure */(4).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(27);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },

    contact: function contact(cb) {
        __webpack_require__.e/* require.ensure */(10).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
            var module = __webpack_require__(24);
            Ensure.loadComplete(module, cb);
        
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }

    /*//APP L2 MODULES:
    overview : function(cb){
        require.ensure(["section/dashboard/Dashboard"], function(){
            let module = require("section/dashboard/Dashboard");
            Ensure.loadComplete(module, cb);
        });
    },
    account : function(cb){
        require.ensure(["section/setting/Setting"], function(){
            let module = require("section/setting/Setting");
            Ensure.loadComplete(module, cb);
        });
    },*/

};

module.exports = Ensure;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//utils:
var Event = __webpack_require__(2);
var Misc = __webpack_require__(1);
var Validator = __webpack_require__(42);
var Formatter = __webpack_require__(5);

var InputHelper = {
    //MAYBE WE SHOULD ONLY DO THIS IF A SECTION WITH INPUT IS OPENED?
    initialize: function initialize() {
        InputHelper.initialized = true;
        Event.enter(".input-wrapper input, .textarea-wrapper textarea", InputHelper.onEnter);
        Event.listen(".input-wrapper .input-file", "change", InputHelper.onFileInputChange);
        Event.listen(".input-wrapper input", "focusin", InputHelper.onInputFocusIn);
        Event.listen(".input-wrapper input", "focusout", InputHelper.onInputFocusOut);
        Event.listen(".input-wrapper input", "customfocusout", InputHelper.onInputFocusOut);
        Event.listen(".input-wrapper input", "keyup", InputHelper.onInputChange);
        Event.listen(".input-wrapper input", "validate", InputHelper.onValidate);
        Event.listen(".input-wrapper input", "reset", InputHelper.onReset);
        Event.listen(".textarea-wrapper textarea", "focusin", InputHelper.onInputFocusIn);
        Event.listen(".textarea-wrapper textarea", "focusout", InputHelper.onInputFocusOut);
        Event.listen(".textarea-wrapper textarea", "keyup", InputHelper.onInputChange);
        Event.listen(".textarea-wrapper textarea", "validate", InputHelper.onTAValidate);
        Event.listen(".textarea-wrapper textarea", "reset", InputHelper.onReset);
        Event.listen("button.ddl, label.btn-look-alike.ddl li", "mark-default", InputHelper.onDLLDefaultRequest);
        Event.listen("button.ddl, label.btn-look-alike.ddl", "reset", InputHelper.onDDLResetRequest);
        Event.tap("button.ddl, label.btn-look-alike.ddl:not(.multi)", InputHelper.onDDLTap);
        Event.tap("button.ddl, label.btn-look-alike.ddl.multi", InputHelper.onMultiDDLTap);
        Event.tap("nav.multi-select button.tab", InputHelper.onMultiSelectBtnTap);
        Event.tap("nav.tab-comp:not(.multi-select) button.tab", InputHelper.onNavTabBtnTap);
        Event.tap(".single-select .tab:not(.active)", InputHelper.onSingleSelectTap);
        Event.tap("form .desc-icon", InputHelper.onDescTap);
        Event.tap(".input-wrapper.img-input-wrapper .span-label.with-value", InputHelper.onFileCancel);
        Event.listen(".input-wrapper .ddl", "validate", InputHelper.onDDLValidate);
    },

    onEnter: function onEnter(e) {
        $(e.currentTarget).blur();
    },
    onDescTap: function onDescTap(e) {
        var $icon = $(e.currentTarget);
        var $parent = $icon.parent();
        $parent.toggleClass("with-desc");
    },


    onNavTabBtnTap: function onNavTabBtnTap(e) {
        var $btn = $(e.currentTarget);
        var $parent = $btn.parent();
        var $activeBtn = $("button.tab.active", $parent);
        if ($activeBtn.attr("id") === $btn.attr("id")) return;
        $activeBtn.removeClass("active");
        $btn.addClass("active");
        $btn.trigger("nav_tab_changed");
    },

    onMultiSelectBtnTap: function onMultiSelectBtnTap(e) {
        var $btn = $(e.currentTarget);
        var $parent = $btn.parent();
        $btn.toggleClass("active");
        var $activeBtns = $("button.tab.active", $parent);
        if ($activeBtns.length === 0) {
            $btn.toggleClass("active");
        }
        $btn.trigger("multi_select_tab_changed");
    },

    onSingleSelectTap: function onSingleSelectTap(e) {
        var $tab = $(e.currentTarget);
        var $parent = $tab.parent();
        $(".tab.active", $parent).removeClass("active");
        $tab.addClass("active");
        $tab.trigger("singleSelectChange");
    },

    onDDLResetRequest: function onDDLResetRequest(e) {
        var $btn = $(e.currentTarget);
        var $parent = $btn.parent();
        var $errLb = $(".error-label", $parent);
        $errLb.css("display", "none");
        $parent.removeClass("focused with-value valid invalid");
        $("label", $btn).removeClass("with-value").text("Select...");
        $("li", $btn).removeClass("active");
        $btn.removeAttr("data-old-value");
    },
    onDLLDefaultRequest: function onDLLDefaultRequest(e) {
        var $li = $(e.currentTarget);
        var $btn = $li.parents(".ddl");
        if ($btn.length === 0) {
            if ($li.hasClass("ddl")) {
                $btn = $li;
                $li = $("li.active", $btn);
            }
        }
        $("label", $btn).addClass("with-value").text($li.text());
        $btn.attr("data-selected-value", $li.attr("data-value"));
        $btn.attr("data-old-value", $li.attr("data-value"));
        $btn.parents(".input-wrapper").addClass("with-value");
        $("li", $btn).removeClass("active");
        $li.addClass("active");
        $btn.trigger({ type: "ddl_changed", selectedValue: $li.attr("data-value") });
    },


    onDDLTap: function onDDLTap(e) {
        var $btn = $(e.currentTarget);
        if ($btn.attr("busy")) return;
        if ($btn.hasClass("off")) return;
        $btn.attr("busy", true);

        var $parent = $btn.parent();
        var $target = $(e.target);
        var isOpen = $btn.hasClass("open");

        var bodyTapFn = function bodyTapFn(bodyEvt) {
            Event.bodyTap(bodyTapFn, true);
            if ($btn.attr("busy")) return;
            Event.bodyTap(bodyTapFn, true);
            $btn.removeClass("open");
            triggerEvent();
            if ($parent.hasClass("invalid")) InputHelper.onDDLValidate(e);
            if ($btn.attr("data-static")) {
                $btn.removeAttr("data-selected-value");
                $("li", $btn).removeClass("active");
            }
        };

        var triggerEvent = function triggerEvent() {
            var newVal = $btn.attr("data-selected-value");
            var oldVal = $btn.attr("data-old-value");
            if (newVal != oldVal) {
                $btn.trigger({ type: "ddl_changed", selectedValue: newVal });
                if (!$btn.attr("data-static")) $btn.attr("data-old-value", newVal);
            }
        };

        if ($parent.hasClass("with-desc")) $parent.removeClass("with-desc");

        if (isOpen) {
            Event.bodyTap(bodyTapFn, true);
            var $liParent = $target.parents(".ddl-item");
            if ($liParent.length > 0) $target = $liParent;
            if ($target.is("li")) {
                var val = $target.attr("data-value");
                $("li", $btn).removeClass("active");
                $btn.attr("data-selected-value", val);
                if (!$btn.attr("data-static")) {
                    $("label", $btn).addClass("with-value").text($target.text());
                    $target.addClass("active");
                    $parent.addClass("with-value");
                }
                triggerEvent();
                if ($parent.hasClass("invalid")) InputHelper.onDDLValidate(e);
            }
            $btn.removeClass("open");
        } else {
            $btn.addClass("open");
            Event.bodyTap(bodyTapFn);
        }
        Misc.callLater(function () {
            $btn.removeAttr("busy");
        }, 250);
    },

    onMultiDDLTap: function onMultiDDLTap(e) {
        var $btn = $(e.currentTarget);
        if ($btn.attr("busy")) return;
        $btn.attr("busy", true);

        var $parent = $btn.parent();
        var $target = $(e.target);
        var isOpen = $btn.hasClass("open");

        var bodyTapFn = function bodyTapFn(bodyEvt) {
            if ($btn.attr("busy")) return;
            Event.bodyTap(bodyTapFn, true);
            $btn.removeClass("open");
        };

        if ($parent.hasClass("with-desc")) $parent.removeClass("with-desc");

        if (isOpen) {
            if ($target.is("li")) {
                var _$parent = $target.parent();
                var $activeLi = $("li.active", _$parent);
                if ($activeLi.length > 1 || !$target.hasClass("active")) {
                    $target.toggleClass("active");
                    var val = $target.attr("data-value");
                    $btn.trigger({ type: "ddl_changed", selectedValue: val });
                }
            } else {
                //close
                Event.bodyTap(bodyTapFn, true);
                $btn.removeClass("open");
            }
        } else {
            $btn.addClass("open");
            Event.bodyTap(bodyTapFn);
        }
        Misc.callLater(function () {
            $btn.removeAttr("busy");
        }, 250);
    },

    onReset: function onReset(e) {
        var $input = $(e.currentTarget);
        var $parent = $input.parent();
        var $errLb = $(".error-label", $parent);
        $errLb.css("display", "none");
        $parent.removeClass("focused with-value valid invalid");
    },

    onInputFocusIn: function onInputFocusIn(e) {
        var $input = $(e.currentTarget);
        if ($input.hasClass("not-this-one")) return;
        var $parent = $input.parent();
        if (!$parent.hasClass(".input-wrapper") || !$parent.hasClass(".textarea-wrapper")) {
            $parent = $input.parents(".input-wrapper");
        }
        $parent.addClass("focused");
    },

    onValidate: function onValidate(e) {
        InputHelper.invokeValidation(e, true);
    },

    onDDLValidate: function onDDLValidate(e) {
        InputHelper.invokeValidation(e, true);
    },

    onTAValidate: function onTAValidate(e) {
        InputHelper.invokeValidation(e, true);
    },

    onInputFocusOut: function onInputFocusOut(e) {
        var $input = $(e.currentTarget);
        var $parent = $input.parent();
        var formatField = $parent.attr("data-format");
        var allowNegative = $input.attr("data-allow") == "negative";
        if (!$parent.hasClass(".input-wrapper") || !$parent.hasClass(".textarea-wrapper")) {
            $parent = $input.parents(".focused");
        }
        $parent.removeClass("focused");
        if ($input.val().length > 0) {
            $parent.addClass("with-value");
            if (formatField) {
                $input.val(Formatter[formatField]($input.val(), allowNegative));
            }
        } else {
            $parent.removeClass("with-value");
        }
    },

    onInputChange: function onInputChange(e) {
        var code = e.which;
        if (code == 13) // is enter no need to execute bellow.
            return;
        InputHelper.invokeValidation(e);
    },

    onFileCancel: function onFileCancel(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        var $parent = $(e.currentTarget).parents(".input-wrapper");
        var $input = $("input", $parent);
        var $label = $('label.file-label', $parent);

        $(".preview-img", $label).attr("src", "");
        $(".span-label", $label).text("Choose A File").removeClass("with-value");
        $input.val("");
    },


    onFileInputChange: function onFileInputChange(e) {
        var $input = $(e.currentTarget);
        var $label = $input.siblings('label.file-label');
        var filename = $input.val().split('\\').pop();
        if (!filename || filename.length < 1) {
            filename = "Choose A File";
            InputHelper.invokeValidation(e, true);
            $(".preview-img", $label).attr("src", "");
            $(".span-label", $label).removeClass("with-value");
        } else {
            $(".span-label", $label).addClass("with-value");
        }
        $(".span-label", $label).text(filename);
    },

    invokeValidation: function invokeValidation(e, force) {
        var $input = $(e.currentTarget);
        var $parent = $input.parent();
        var validatorName = $parent.attr("data-input-validator");
        var optionalValidatorName = $parent.attr("data-input-validator2");
        var $errLb = $(".error-label", $parent);
        var isOptional = false;
        if (optionalValidatorName) {
            force = false;
            isOptional = true;
            validatorName = optionalValidatorName;
        }
        var val = $input.val();
        if ($input.hasClass("ddl")) val = $input.attr("data-selected-value");
        if (validatorName) {
            if (val && val.length > 0 || force) {
                var isValidNow = $parent.hasClass("valid");
                var isValid = Validator[validatorName](val, $input);
                if (isValid) {
                    $parent.addClass("valid").removeClass("invalid");
                    $errLb.css("display", "none");
                } else if (isValidNow || force || isOptional) {
                    $parent.addClass("invalid").removeClass("valid");
                    $errLb.css("display", "inline-block");
                    Misc.scrollToElm($parent, 170);
                }
            } else {
                $parent.removeClass("invalid valid");
                $errLb.css("display", "none");
            }
        }
    }
};

module.exports = InputHelper;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Firebase = __webpack_require__(7);

var Logger = {
    getLogObj: function getLogObj() {
        if (this.logObj) return this.logObj;
        var w = window.innerWidth;
        var h = window.innerHeight;
        var state = "desktop-likely";
        var browser = this.getBrowserDetails();
        if (w <= 500 && h <= 800) {
            state = "mobile-likely";
        } else if (w <= 1200 && h <= 1000) {
            state = "tablet-likely";
        }
        try {
            this.logObj = {
                userAgent: navigator.userAgent ? navigator.userAgent : "n/a",
                platform: browser,
                screen: w + " x " + h,
                device: state
            };
            return this.logObj;
        } catch (e) {}
        return {};
    },
    onPathChange: function onPathChange() {
        var path = window.location.pathname;
        if (this.path == path) return;
        this.path = path;
        var obj = this.getLogObj();
        obj.path = path;
        Firebase.log("navigation", obj, this.onLogDone.bind(this));
    },
    onLogDone: function onLogDone(data) {},
    getBrowserDetails: function getBrowserDetails() {
        var nVer = navigator.appVersion;
        var nAgt = navigator.userAgent;
        var browserName = navigator.appName;
        var fullVersion = '' + parseFloat(navigator.appVersion);
        var majorVersion = parseInt(navigator.appVersion, 10);
        var nameOffset, verOffset, ix;

        // In Opera, the true version is after "Opera" or after "Version"
        if ((verOffset = nAgt.indexOf("Opera")) != -1) {
            browserName = "Opera";
            fullVersion = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf("Version")) != -1) fullVersion = nAgt.substring(verOffset + 8);
        }
        // In MSIE, the true version is after "MSIE" in userAgent
        else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
                browserName = "Microsoft Internet Explorer";
                fullVersion = nAgt.substring(verOffset + 5);
            }
            // In Chrome, the true version is after "Chrome"
            else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
                    browserName = "Chrome";
                    fullVersion = nAgt.substring(verOffset + 7);
                }
                // In Safari, the true version is after "Safari" or after "Version"
                else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
                        browserName = "Safari";
                        fullVersion = nAgt.substring(verOffset + 7);
                        if ((verOffset = nAgt.indexOf("Version")) != -1) fullVersion = nAgt.substring(verOffset + 8);
                    }
                    // In Firefox, the true version is after "Firefox"
                    else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
                            browserName = "Firefox";
                            fullVersion = nAgt.substring(verOffset + 8);
                        }
                        // In most other browsers, "name/version" is at the end of userAgent
                        else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
                                browserName = nAgt.substring(nameOffset, verOffset);
                                fullVersion = nAgt.substring(verOffset + 1);
                                if (browserName.toLowerCase() == browserName.toUpperCase()) {
                                    browserName = navigator.appName;
                                }
                            }
        // trim the fullVersion string at semicolon/space if present
        if ((ix = fullVersion.indexOf(";")) != -1) fullVersion = fullVersion.substring(0, ix);
        if ((ix = fullVersion.indexOf(" ")) != -1) fullVersion = fullVersion.substring(0, ix);

        majorVersion = parseInt('' + fullVersion, 10);
        if (isNaN(majorVersion)) {
            fullVersion = '' + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
        }
        fullVersion = fullVersion.replace(/\./g, "-");
        return browserName + "(" + fullVersion + ")";
    }
};

module.exports = Logger;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Router = __webpack_require__(17);
var _Ensure = __webpack_require__(37);
var _Logger = __webpack_require__(39);

//UTILS
var _FB = __webpack_require__(7);
var _Charts = __webpack_require__(19);
var _Misc = __webpack_require__(1);

//Views:
var Header = __webpack_require__(44);
var Footer = __webpack_require__(43);

//ENUM:
var ENUM = __webpack_require__(13);

//HELPERs
var _InputHelper = __webpack_require__(38);

Router.initialize = function () {
    this.init(); // in HISTORY

    this.sectionsId = "#sections";
    this.pages = {};
    this.appStarted = false;
    this.currentPage = null;
    this.currentL2Page = null;

    // create static Components:
    Router.header = new Header();
    Router.footer = new Footer();

    setMainPage();
};

Router.historyChangedHandler = function () {
    setMainPage();
    setPaths();
};

//private:

function setPaths() {
    if (!Router.currentPage) return;
    if (Router.currentPage.ready) {
        Router.currentPage.pathChanged(Router.l1, Router.l2, Router.l3, Router.l4, Router.l5);
    }

    if (Router.currentPage.requireL2Modules && Router.currentL2Page && Router.currentL2Page.ready) {
        Router.currentL2Page.pathChanged(Router.l1, Router.l2, Router.l3, Router.l4, Router.l5);
    }

    Router.header.pathChanged(Router.l1, Router.l2, Router.l3);
    Router.footer.pathChanged(Router.l1, Router.l2, Router.l3);

    _Logger.onPathChange();
}

function pageSetupComplete() {
    Router.pageReady = true;
    if (Router.l1 != 'in') {
        Router.header.show();
        Router.footer.show();
    }
};

function setMainPage() {
    var page = getPageBasedOnLevelPath(0);
    if (!page) {
        _Misc.setOverlay(true, true);
        return;
    }
    if (page.requireInputHelper && !_InputHelper.initialized) {
        _InputHelper.initialize();
    }
    switchPages(page);
    if (page.requireL2Modules) {
        var l2Page = getPageBasedOnLevelPath(1);
        if (!l2Page) {
            _Misc.setOverlay(true, true);
            return;
        }
        switchL2Pages(l2Page);
    }
};

function loadExternalDependencies() {
    var _resume = function () {
        _Misc.callLater(this.createChildren.bind(this));
    }.bind(this);
    if (this.requireFirebase && !_FB.initialized) {
        _FB.invoke(function () {
            _resume();
        });
    } else if (this.requireCharts && !_Charts.initialized) {
        _Charts.invoke(function () {
            _resume();
        });
    } else {
        _resume();
    }
};

function switchPages(newPage) {
    var currentPage = Router.currentPage;
    if (!newPage || currentPage && newPage.id === currentPage.id) return;
    newPage.show();
    if (currentPage) {
        currentPage.hide();
    }

    Router.currentPage = newPage;
    setPaths();
    _Misc.setOverlay(false, false);
    if (!Router.pageReady) {
        pageSetupComplete();
    }
};

function switchL2Pages(newPage) {
    var currentL2Page = Router.currentL2Page;
    if (!newPage || currentL2Page && newPage.id === currentL2Page.id) return;

    newPage.show();
    if (currentL2Page) {
        currentL2Page.hide();
    }
    _Misc.setOverlay(false, false);
    Router.currentL2Page = newPage;
    var p = Router.l1 + Router.l2 + Router.l3;
    if (p === Router.currentL2Page.path) return;
    Router.currentL2Page.path = p;
    Router.currentL2Page.pathChanged(Router.l1, Router.l2, Router.l3, Router.l4, Router.l5);
};

function getPageBasedOnLevelPath(pathIdx) {
    var lPath = Router.getLevelPath(pathIdx);
    var moduleName = ENUM.VIEWS.getModuleName(lPath);
    if (pathIdx > 0 && moduleName === ENUM.VIEWS.DEFAULT) return;
    var page = Router.pages[moduleName];
    if (!page) {
        Router.footer.hide();
        _Ensure.load(moduleName, function (Module) {
            var sel = pathIdx === 0 ? Router.sectionsId : Router.currentPage.$self;
            var page = new Module(sel);
            page.hasExternalDependencies = loadExternalDependencies;
            page.readyOnDOM = function () {
                page.readyOnDOM = null;
                Router.pages[moduleName] = page;
                setMainPage();
                _Misc.callLater(function () {
                    if (Router.l1 != "in") Router.footer.show();
                });
            };
        });
        return null;
    }
    return page;
};

module.exports = Router;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sanitizer = {
    invoke: function invoke(data) {
        return;
        for (var propName in data) {
            var propVal = data[propName];
            if (data[propName]) data[propName] = Sanitizer.validate(propVal);else delete data[propName];
        }
    },
    validate: function validate(s) {
        if (typeof s === "string") return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
        return s;
    }
};

module.exports = Sanitizer;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Validator = {
    reqText: function reqText(txt) {
        var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

        return txt && txt.length > min && txt.length < max;
    },

    email: function email(_email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(_email);
    },

    required: function required(str) {
        return str && str.length > 0;
    },

    password: function password(str) {
        return str && str.length > 5;
    },

    phone: function phone(str) {
        var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        return str.match(phoneno);
    },

    img_upload: function img_upload(str, $input) {
        try {
            var file = $input[0].files[0];
            var name = file.name;
            var size = file.size / 1000000;
            var extension = name.split('.').pop().toLowerCase();
            var isValid = true;
            if (extension.indexOf("jpg") < 0 && extension.indexOf("jpeg") < 0 && extension.indexOf("png") < 0) isValid = false;
            if (size > 5000000) isValid = false;
            return isValid;
        } catch (e) {
            return false;
        }
    }
};

module.exports = Validator;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//SCSS
__webpack_require__(56);

var UIComponent = __webpack_require__(10);

//HTMLS:
var HTML = __webpack_require__(52);

var Footer = function (_UIComponent) {
    _inherits(Footer, _UIComponent);

    function Footer() {
        _classCallCheck(this, Footer);

        return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, "#main", HTML, false));
    }

    _createClass(Footer, [{
        key: "show",
        value: function show() {
            _get(Footer.prototype.__proto__ || Object.getPrototypeOf(Footer.prototype), "show", this).call(this);
        }
    }, {
        key: "hide",
        value: function hide() {
            _get(Footer.prototype.__proto__ || Object.getPrototypeOf(Footer.prototype), "hide", this).call(this);
        }
    }, {
        key: "pathChanged",
        value: function pathChanged(l1, l2, l3) {
            if (l1 === "app") this.ready = false;else {
                this.ready = true;
            }
        }
    }]);

    return Footer;
}(UIComponent);

;

module.exports = Footer;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//SCSS
__webpack_require__(57);

//BASE
var UIComponent = __webpack_require__(10);

//UTILS:
var _Event = __webpack_require__(2);
var _Misc = __webpack_require__(1);
var _FireAuth = __webpack_require__(12);

//HTMLS:
var HTML = __webpack_require__(53);

var Header = function (_UIComponent) {
    _inherits(Header, _UIComponent);

    function Header() {
        _classCallCheck(this, Header);

        return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, "#main", HTML, true));
    }

    _createClass(Header, [{
        key: "initialize",
        value: function initialize() {
            _get(Header.prototype.__proto__ || Object.getPrototypeOf(Header.prototype), "initialize", this).call(this, false);
        }
    }, {
        key: "createChildren",
        value: function createChildren() {
            _get(Header.prototype.__proto__ || Object.getPrototypeOf(Header.prototype), "createChildren", this).call(this);
        }
    }, {
        key: "addEventListeners",
        value: function addEventListeners() {
            _get(Header.prototype.__proto__ || Object.getPrototypeOf(Header.prototype), "addEventListeners", this).call(this);
            this.bodyFn = this.onMenuTap.bind(this);
            this.betaBodyTap = this.onBodyTap.bind(this);
            _Event.tap(".header-menu", this.bodyFn, this.$self);
            _Event.tap(".beta", this.onBetaTap.bind(this), this.$self);
        }
    }, {
        key: "initialized",
        value: function initialized() {
            _get(Header.prototype.__proto__ || Object.getPrototypeOf(Header.prototype), "initialized", this).call(this);
        }
    }, {
        key: "onMenuTap",
        value: function onMenuTap() {
            if (Header.busy) return;
            this.busy = true;
            var $linkWrapper = $(".link-wrapper", this.$self);
            var isOpen = $linkWrapper.hasClass("active");
            var cls = isOpen ? "fadeOutUp" : "active fadeInDown";
            $linkWrapper.addClass(cls);
            _Misc.callLater(function () {
                this.busy = false;
                cls = isOpen ? "active fadeOutUp" : "fadeInDown";
                $linkWrapper.removeClass(cls);
                _Event.bodyTap(this.bodyFn, isOpen);
            }.bind(this), 250);
        }
    }, {
        key: "pathChanged",
        value: function pathChanged(l1, l2, l3) {
            var $linkWrapper = $(".link-wrapper", this.$self);
            var $a = $("a[href='/" + l1 + "']", $linkWrapper);
            var $as = $("a", $linkWrapper);
            $as.removeClass("active");
            $a.addClass("active");
        }
    }, {
        key: "onBetaTap",
        value: function onBetaTap() {
            _Misc.setOverlay(true, false);
            $("#betaInfo").css("display", "flex");
            _Event.bodyTap(this.betaBodyTap);
        }
    }, {
        key: "onBodyTap",
        value: function onBodyTap() {
            _Misc.setOverlay(false, false);
            $("#betaInfo").css("display", "none");
            _Event.bodyTap(this.betaBodyTap, true);
        }
    }]);

    return Header;
}(UIComponent);

module.exports = Header;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports
exports.i(__webpack_require__(48), "");

// module
exports.push([module.i, "i:before{content:\"v\";font-family:ieo}i.i-info{color:#d8d8d8}/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,footer,header,nav,section{display:block}h1{margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}.animated{-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.animated.quick{-webkit-animation-duration:.25s;animation-duration:.25s}.animated.long{-webkit-animation-duration:5.5s;animation-duration:5.5s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{animation-name:fadeIn}@keyframes fadeInDown{0%{opacity:0;transform:translate3d(0,-100%,0)}to{opacity:1;transform:none}}.fadeInDown{animation-name:fadeInDown}@keyframes fadeInLeft{0%{opacity:0;transform:translate3d(-100%,0,0)}to{opacity:1;transform:none}}.fadeInLeft{animation-name:fadeInLeft}@keyframes fadeInRight{0%{opacity:0;transform:translate3d(100%,0,0)}to{opacity:1;transform:none}}.fadeInRight{animation-name:fadeInRight}@keyframes fadeInUp{0%{opacity:0;transform:translate3d(0,100%,0)}to{opacity:1;transform:none}}.fadeInUp{animation-name:fadeInUp}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{animation-name:fadeOut}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;transform:translate3d(0,100%,0)}}.fadeOutDown{animation-name:fadeOutDown}@keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;transform:translate3d(-100%,0,0)}}.fadeOutLeft{animation-name:fadeOutLeft}@keyframes fadeOutRight{0%{opacity:1}to{opacity:0;transform:translate3d(100%,0,0)}}.fadeOutRight{animation-name:fadeOutRight}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;transform:translate3d(0,-100%,0)}}.fadeOutUp{animation-name:fadeOutUp}.truncate{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}h1,h2,h3,h4,h5,h6{margin:0}h1{color:#1a1a1a;text-align:center;padding:20px 0;font-size:2em;text-transform:capitalize}h2{font-size:40px;padding:20px 0}h2,h3{color:#089e8a;font-weight:300}h3{text-align:center;font-size:28px}h4{color:#1a1a1a;font-size:24px}h4,h5{font-weight:300;text-align:center}h5{color:#777;font-size:20px}h6{color:#777}h6,p{font-weight:300;text-align:center;font-size:17px}p{margin:0;color:#1a1a1a;line-height:25px}p.info-text{color:#777;text-align:justify}p.info-text.center{text-align:center}i{margin:0;color:#777;text-align:justify;font-weight:300}.error-txt{color:red;font-size:15px}.imp{color:#089e8a}.red{color:red}.green{color:green}.blue{color:#2a5db0}.orange{color:#ef9000}.bld{font-weight:500}label.ddl.btn-look-alike.h2-look-alike{color:#089e8a;font-weight:300;text-align:center;font-size:35px;border:0;padding:0 20px 0 0}label.ddl.btn-look-alike.h2-look-alike label{color:#1a1a1a}label.ddl.btn-look-alike.h2-look-alike:after{top:50%;margin-top:-5px;color:#777}blockquote{display:block;padding:20px 5px 5px 30px;margin:2px;position:relative;line-height:1.5}blockquote:before{content:\"\\201C\";font-size:80px;color:#089e8a;position:absolute;left:-20px;top:-20px}blockquote .quote{font-size:17px;text-align:left;font-style:italic;color:#777}blockquote:after{content:\"\"}blockquote .title{font-style:italic}blockquote footer{display:block;text-align:right;margin-top:10px;font-style:normal;color:#1a1a1a}blockquote footer a{color:#2a5db0}a,label.link-looking,label.tab{color:#777;transition:color .25s;-webkit-tap-highlight-color:transparent;text-decoration:none;font-size:16px;font-weight:300;cursor:pointer}a:hover:not(.active,.btn),label.link-looking:hover:not(.active,.btn),label.tab:hover:not(.active,.btn){text-decoration:underline}a.active,label.link-looking.active,label.tab.active{color:#089e8a;cursor:default}a.unique,label.link-looking.unique,label.tab.unique{color:#9c27b0}a.has-i,label.link-looking.has-i,label.tab.has-i{display:flex;align-items:center;justify-content:center}a.has-i:before,label.link-looking.has-i:before,label.tab.has-i:before{font-size:20px;padding-right:5px}a.classic,label.link-looking.classic,label.tab.classic{color:#2a5db0}a.classic:hover,label.link-looking.classic:hover,label.tab.classic:hover{color:#20c}.btn-a:hover{text-decoration:none!important}aside,div,footer,header,nav,section{display:flex;align-items:flex-start}.full-page-container{margin:0 auto;width:100%}.fixed-content-container{margin:0 auto!important;max-width:1280px!important;width:90%!important}@media (max-width:600px){.fixed-content-container.stretch{width:100%!important;max-width:none!important}.fixed-content-container.stretch,.fixed-content-container.stretch .budget-item,.fixed-content-container.stretch .content-item{border-left:0!important;border-right:0!important}.fixed-content-container.stretch .section-content{border:0}.fixed-content-container.stretch.section-content{border-left:0!important;border-right:0!important}}.ad-space{padding:30px 0 0}.tabs-holder{width:100%;border-bottom:1px solid #089e8a;background:#fff}.tabs-holder nav{height:60px}.tabs-holder nav label.tab{width:100%;text-align:center;height:100%;font-size:20px;box-sizing:border-box;display:flex;align-items:center;justify-content:center;border-left:1px solid #fff;border-right:1px solid #fff;border-top:1px solid #fff}.tabs-holder nav label.tab:hover:not(.active){text-decoration:none;background:#f9f9f9}.tabs-holder nav label.tab.active{background:#edf9f7;height:61px;border-left:1px solid #089e8a;border-right:1px solid #089e8a;border-top:1px solid #089e8a}.space-between{justify-content:space-between}.space-around{justify-content:space-around}.justify-center{justify-content:center}.justify-self-center{justify-self:center;align-self:center}.v-aligned{align-items:center}.normal-aligned{align-items:normal}.h-left-aligned{align-items:flex-start;justify-content:flex-start}.column{flex-direction:column}.wrap{flex-wrap:wrap}.pull-right{margin-left:auto}.hidden{display:none!important}.invisible{visibility:hidden!important}.full-width{width:100%}.highlight{background:#f7ee4e}.margin-top-10{margin-top:10px}.margin-left-right-10{margin:0 10px}.margin-top-20{margin-top:20px}.margin-top-30{margin-top:30px}.margin-up-down-10{margin:10px 0}.margin-up-down-20{margin:20px 0}.margin-up-down-30{margin:30px 0}.margin-right-10{margin-right:10px}.margin-left-10{margin-left:10px}.padding-side-10{padding:0 10px;box-sizing:border-box}.blur{filter:blur(2px)}.i-expense:before{color:#ef9000!important}.i-income:before{color:green!important}.i-allocation:before{color:#4f84c4!important}[class^=i-]{display:flex;align-items:center}.img-holder{position:relative;height:100%;width:100%;background-position:50%;background-repeat:no-repeat;background-size:cover;display:flex;justify-content:center;box-sizing:border-box;background-color:#f0f0f0;min-height:100px}button,label.btn-look-alike{border:1px solid;border-color:#d8d8d8;color:#1a1a1a;font-weight:200;padding:12px;font-size:18px;transition:opacity .25s;cursor:pointer;appearance:none;opacity:1;border-radius:0}button.white,label.btn-look-alike.white{border-color:#fff;background:hsla(0,0%,98%,.1);color:#fff}button.white:hover,label.btn-look-alike.white:hover{border-color:#fff;background:hsla(0,0%,98%,.2);color:#fff;text-decoration:none}button.disabled,label.btn-look-alike.disabled{opacity:.5;cursor:default}button.disabled.arrow-btn .arrow,label.btn-look-alike.disabled.arrow-btn .arrow{cursor:default!important}button.transparent,label.btn-look-alike.transparent{background:hsla(0,0%,98%,0);border-color:#d8d8d8;overflow:hidden;box-shadow:inset 0 10px 15px -10px #aeb0b3;font-weight:400}button.transparent.arrow-btn .arrow,label.btn-look-alike.transparent.arrow-btn .arrow{border-color:inherit}button.transparent.has-i:hover:before,label.btn-look-alike.transparent.has-i:hover:before{color:#089e8a}button.margin-sides-10,label.btn-look-alike.margin-sides-10{margin:0 10px}button.large,label.btn-look-alike.large{font-size:22px}button.small,label.btn-look-alike.small{padding:5px 10px}button.shine,label.btn-look-alike.shine{border-color:#089e8a;color:#fff;background:#089e8a;font-weight:400}button.shine:hover,label.btn-look-alike.shine:hover{color:#fff}button:hover:not(.disabled),label.btn-look-alike:hover:not(.disabled){opacity:1}button.unique,label.btn-look-alike.unique{border-color:#9c27b0;color:#fff;background:#9c27b0;text-shadow:0 0 1px #1a1a1a}button.unique-outline,label.btn-look-alike.unique-outline{border-color:#9c27b0;color:#9c27b0}button.red-outline,label.btn-look-alike.red-outline{border-color:red;color:red;box-shadow:none;opacity:1}button.red-outline:hover:before,label.btn-look-alike.red-outline:hover:before{color:red!important}button.green-outline,label.btn-look-alike.green-outline{border-color:green;color:green;background:#fff}button.primary-outline,label.btn-look-alike.primary-outline{border-color:#089e8a;color:#089e8a;box-shadow:none}button:focus,label.btn-look-alike:focus{outline:none}button.has-i,label.btn-look-alike.has-i{display:flex;align-items:center;justify-content:center}button.has-i:before,label.btn-look-alike.has-i:before{font-size:20px;padding-right:5px}button.active,label.btn-look-alike.active{border-color:#089e8a;color:#089e8a}button.fixed40,label.btn-look-alike.fixed40{padding:0 10px;height:35px;min-width:35px}button.tab,label.btn-look-alike.tab{background:#f0f0f0;margin-right:-1px;padding:10px;text-transform:capitalize;box-shadow:inset 0 10px 30px -10px #aeb0b3}button.tab.fixed40,label.btn-look-alike.tab.fixed40{padding:0 10px}button.tab.first,label.btn-look-alike.tab.first{border-radius:10px 0 0 10px;margin-left:10px}button.tab.last,label.btn-look-alike.tab.last{border-radius:0 10px 10px 0}button.tab.active,label.btn-look-alike.tab.active{background:#fff;box-shadow:inset 0 0 1px 1px #f0f0f0;z-index:10}button.tab:hover:not(.active):not(.disabled),label.btn-look-alike.tab:hover:not(.active):not(.disabled){color:#777;background:#f9f9f9;border-color:#aeb0b3}button.ddl,label.btn-look-alike.ddl{position:relative;display:flex;padding-right:20px;overflow:visible;opacity:1;border-color:#d8d8d8}button.ddl.small,label.btn-look-alike.ddl.small{padding:0 20px 0 5px;height:28px;border-color:#d8d8d8}button.ddl label,label.btn-look-alike.ddl label{overflow:hidden;cursor:pointer}button.ddl label.dll-label,label.btn-look-alike.ddl label.dll-label{font-weight:400;color:#aeb0b3;font-size:16px}button.ddl label.dll-label.with-value,label.btn-look-alike.ddl label.dll-label.with-value{color:#1a1a1a}button.ddl:hover,label.btn-look-alike.ddl:hover{background:#f9f9f9}button.ddl:after,label.btn-look-alike.ddl:after{position:absolute;content:\"q\";font-family:ieo;color:#777;right:4px;font-size:10px;align-self:center;top:auto}button.ddl:not(.open):hover:after,label.btn-look-alike.ddl:not(.open):hover:after{color:#089e8a}button.ddl.open,label.btn-look-alike.ddl.open{border-radius:0}button.ddl.open ul,label.btn-look-alike.ddl.open ul{display:block}button.ddl.open.full ul,label.btn-look-alike.ddl.open.full ul{left:-1px}button.ddl.open:after,label.btn-look-alike.ddl.open:after{content:\"j\"}button.ddl.show-on-top ul,label.btn-look-alike.ddl.show-on-top ul{bottom:100%;top:auto}button.ddl.h2-look-alike:after,label.btn-look-alike.ddl.h2-look-alike:after{font-size:18px;right:-5px;top:17px}button.ddl.h2-look-alike ul,label.btn-look-alike.ddl.h2-look-alike ul{width:100%;margin-top:10px}button.ddl.h2-look-alike ul li,label.btn-look-alike.ddl.h2-look-alike ul li{font-size:20px;padding:15px}button.ddl ul,label.btn-look-alike.ddl ul{display:none;position:absolute;top:100%;right:-1px;background:#fff;border:1px solid #d8d8d8;list-style:none;padding:0;box-sizing:border-box;box-shadow:0 0 100px 1px #c6c8cb;margin:0;z-index:100}button.ddl ul.open-up,label.btn-look-alike.ddl ul.open-up{top:auto;bottom:100%}button.ddl ul.full-width,label.btn-look-alike.ddl ul.full-width{width:100%;box-sizing:content-box}button.ddl ul li,label.btn-look-alike.ddl ul li{text-align:left;padding:5px 10px;color:#555;font-weight:400;font-size:16px}button.ddl ul li:hover:not(.active),label.btn-look-alike.ddl ul li:hover:not(.active){background:#f9f9f9}button.ddl ul li.active,label.btn-look-alike.ddl ul li.active{color:#089e8a}button.sso,label.btn-look-alike.sso{background:none;position:relative;padding-right:65px;min-width:275px;width:70%}button.sso:hover,label.btn-look-alike.sso:hover{background:#f9f9f9}button.sso:before,label.btn-look-alike.sso:before{position:absolute;color:#fff;right:0;top:0;bottom:0;width:50px;text-align:center;line-height:58px;font-size:40px}button.sso.facebook,label.btn-look-alike.sso.facebook{border-color:#526bc8;color:#526bc8;margin-top:20px}button.sso.facebook:before,label.btn-look-alike.sso.facebook:before{background:#526bc8}button.sso.google,label.btn-look-alike.sso.google{border-color:#4285f4;color:#4285f4;margin-top:10px}button.sso.google:before,label.btn-look-alike.sso.google:before{background:#4285f4}button.delete-btn.open{padding:5px 10px}button.delete-btn:hover:before{color:red!important}.arrow-wrapper{position:absolute;align-items:center;justify-content:center;padding:20px 10px;z-index:1;cursor:pointer}.arrow-wrapper.left{left:0}.arrow-wrapper.left.bg{background:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.arrow-wrapper.left.bg.grey{background:linear-gradient(90deg,#f9f9f9,hsla(0,0%,100%,0))}.arrow-wrapper.right{right:0}.arrow-wrapper.right.bg{background:linear-gradient(90deg,hsla(0,0%,100%,0),#fff)}.arrow-wrapper.right.bg.grey{background:linear-gradient(90deg,hsla(0,0%,98%,0),#f9f9f9)}.arrow-wrapper:hover .arrow{border-color:#089e8a;width:30px;height:30px}.arrow,.arrow-wrapper:hover .arrow.small{width:20px;height:20px}.arrow{border:solid #aeb0b3;transform:rotate(45deg);-webkit-transform:rotate(45deg);cursor:pointer;z-index:1;transition:width .25s,height .25s}.arrow.down{margin-bottom:10px;border-width:0 2px 2px 0}.arrow.up{border-width:2px 0 0 2px;margin-top:10px}.arrow.left{border-width:0 0 4px 4px;margin-left:10px}.arrow.left.small{border-width:0 0 2px 2px;margin-left:5px}.arrow.right{border-width:4px 4px 0 0;margin-right:10px}.arrow.right.small{border-width:2px 2px 0 0;margin-right:5px}.arrow:hover{border-color:#089e8a;width:30px;height:30px}.arrow.small{width:10px;height:10px}.loader{border:2px solid #f9f9f9;border-top:2px solid #089e8a;border-radius:50%;width:40px;height:40px;animation:spin 2s linear infinite;position:absolute;top:50%;margin-top:-20px;left:50%;margin-left:-20px;box-sizing:border-box}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.v-divider{height:100%;width:1px;background:#f0f0f0}.h-divider{width:100%;height:1px;background:#f0f0f0}nav.tab-comp{box-sizing:border-box}nav.tab-comp.vertical{flex-direction:column;padding:0 10px}nav.tab-comp.vertical a.tab{margin:0;width:100%}nav.tab-comp.vertical a.tab.first{border-radius:0;margin-left:0}nav.tab-comp.vertical a.tab.last{border-radius:0;margin-right:0}nav.tab-comp a.tab{background:#f0f0f0;border-color:#aeb0b3;margin-right:-1px;padding:15px;border:1px solid #aeb0b3;font-weight:400;text-transform:capitalize;box-shadow:inset 0 0 1px 1px #fff}nav.tab-comp a.tab.first{border-radius:10px 0 0 10px;margin-left:10px}nav.tab-comp a.tab.last{border-radius:0 10px 10px 0}nav.tab-comp a.tab.active{background:#fff;box-shadow:inset 0 0 1px 1px #f0f0f0;color:#089e8a;border-color:#089e8a;z-index:10}nav.tab-comp a.tab.active:hover{cursor:default}nav.tab-comp a.tab:hover:not(.active){color:#777;background:#f9f9f9}.sub-section nav.sub-nav{background:#f0f0f0;border-bottom:1px solid #aeb0b3;height:65px;position:fixed;z-index:2}.sub-section nav.sub-nav .link-wrapper{height:100%;align-items:center}.sub-section nav.sub-nav .link-wrapper a{margin:0 10px;color:#1a1a1a;text-transform:capitalize}.sub-section nav.sub-nav .link-wrapper a:first-child{margin-left:0}.sub-section nav.sub-nav .link-wrapper a.active{color:#777}.sub-section nav.sub-nav .link-wrapper a:hover:not(.active){color:#089e8a}.sub-section .section-wrapper{padding-top:65px}@media (max-width:400px){.sub-section nav.sub-nav{position:inherit;height:auto;padding:10px 0}.sub-section nav.sub-nav .link-wrapper{flex-direction:column;align-items:center}.sub-section nav.sub-nav .link-wrapper a:first-child{margin-top:0}.sub-section nav.sub-nav .link-wrapper a{margin:10px 0 0}.sub-section .section-wrapper{padding-top:0}}.single-select.small .tab{padding:3px 5px}@media (max-width:500px){.single-select{flex-wrap:wrap}.single-select .tab{width:100%;border-radius:0!important;margin:-1px 0 0!important}}.key-value-wrapper{align-items:stretch;width:100%;margin-bottom:2px}.key-value-wrapper.no-margin{margin:0}.key-value-wrapper .key{color:#777;width:30%;padding:10px;border-right:2px solid #fff;background:#f9f9f9;justify-content:flex-end;flex-wrap:wrap;align-content:flex-start;font-weight:200}.key-value-wrapper .value{width:70%;background:#f9f9f9;padding:10px;flex-wrap:wrap}.key-value-wrapper .value.no-wrap{flex-wrap:nowrap}.key-value-wrapper .value.right-aligned{text-align:right}.key-value-wrapper .value .sub-value{display:inline-block;width:100%;text-align:center}.key-value-wrapper .value .sub-value.last{border-left:2px solid #fff;padding-left:10px}div.form-like,form{display:flex;flex-direction:column;width:100%;align-items:normal}div.form-like .pair-wrapper,form .pair-wrapper{align-items:inherit}div.form-like .pair-wrapper .input-wrapper:first-child,form .pair-wrapper .input-wrapper:first-child{margin-right:15px}div.form-like .pair-wrapper .input-wrapper:last-child,form .pair-wrapper .input-wrapper:last-child{margin-left:15px}div.form-like .pair-wrapper .textarea-wrapper:first-child,form .pair-wrapper .textarea-wrapper:first-child{margin-right:15px}div.form-like .pair-wrapper .textarea-wrapper:last-child,form .pair-wrapper .textarea-wrapper:last-child{margin-left:15px}div.form-like .pair-wrapper.first .input-wrapper,form .pair-wrapper.first .input-wrapper{margin-top:0}@media (max-width:850px){div.form-like .pair-wrapper,form .pair-wrapper{flex-direction:column}div.form-like .pair-wrapper .input-wrapper:first-child,form .pair-wrapper .input-wrapper:first-child{margin-right:0}div.form-like .pair-wrapper .input-wrapper:last-child,form .pair-wrapper .input-wrapper:last-child{margin-left:0}div.form-like .pair-wrapper .textarea-wrapper:first-child,form .pair-wrapper .textarea-wrapper:first-child{margin-right:0}div.form-like .pair-wrapper .textarea-wrapper:last-child,form .pair-wrapper .textarea-wrapper:last-child{margin-left:0}div.form-like .pair-wrapper.first .input-wrapper,form .pair-wrapper.first .input-wrapper{margin-top:30px}div.form-like .pair-wrapper.first .input-wrapper:first-child,form .pair-wrapper.first .input-wrapper:first-child{margin-top:0}}div.form-like textarea,form textarea{min-height:70px}div.form-like input,form input{max-height:18px}div.form-like input,div.form-like textarea,form input,form textarea{flex:1;margin:0;font-size:16px;appearance:none;box-shadow:inset 0 0 1px 0 #d8d8d8;border-radius:none;resize:none;color:#000;padding:15px 20px;border:1px solid #d8d8d8;z-index:1;background:#fff;transition:background .25s}div.form-like input::-webkit-input-placeholder,div.form-like textarea::-webkit-input-placeholder,form input::-webkit-input-placeholder,form textarea::-webkit-input-placeholder{color:#aeb0b3;font-weight:400}div.form-like input::-moz-placeholder,div.form-like textarea::-moz-placeholder,form input::-moz-placeholder,form textarea::-moz-placeholder{color:#aeb0b3;font-weight:400}div.form-like input:-ms-input-placeholder,div.form-like textarea:-ms-input-placeholder,form input:-ms-input-placeholder,form textarea:-ms-input-placeholder{color:#aeb0b3;font-weight:400}div.form-like input:-moz-placeholder,div.form-like textarea:-moz-placeholder,form input:-moz-placeholder,form textarea:-moz-placeholder{color:#aeb0b3;font-weight:400}div.form-like input:hover:not(.disabled):not(.no-hover),div.form-like textarea:hover:not(.disabled):not(.no-hover),form input:hover:not(.disabled):not(.no-hover),form textarea:hover:not(.disabled):not(.no-hover){background:#f9f9f9}div.form-like input:focus,div.form-like textarea:focus,form input:focus,form textarea:focus{outline:none;background:#f9f9f9}div.form-like input[type=date],div.form-like textarea[type=date],form input[type=date],form textarea[type=date]{color:#aeb0b3}div.form-like .input-wrapper,div.form-like .textarea-wrapper,form .input-wrapper,form .textarea-wrapper{margin-top:30px;transition:padding-bottom .3s;min-width:40px;display:flex;flex-direction:column;width:100%;align-items:inherit;position:relative}div.form-like .input-wrapper.row,div.form-like .textarea-wrapper.row,form .input-wrapper.row,form .textarea-wrapper.row{flex-direction:row;align-items:center}div.form-like .input-wrapper.row .for-label,div.form-like .textarea-wrapper.row .for-label,form .input-wrapper.row .for-label,form .textarea-wrapper.row .for-label{margin-right:10px}div.form-like .input-wrapper.row input,div.form-like .textarea-wrapper.row input,form .input-wrapper.row input,form .textarea-wrapper.row input{margin-right:40px}div.form-like .input-wrapper.disabled input,div.form-like .textarea-wrapper.disabled input,form .input-wrapper.disabled input,form .textarea-wrapper.disabled input{color:#c6c8cb;background:#f9f9f9;border-width:0}div.form-like .input-wrapper.with-value.has-i-dot:not(.is-open) .i-dot,div.form-like .textarea-wrapper.with-value.has-i-dot:not(.is-open) .i-dot,form .input-wrapper.with-value.has-i-dot:not(.is-open) .i-dot,form .textarea-wrapper.with-value.has-i-dot:not(.is-open) .i-dot{display:none!important}div.form-like .input-wrapper.with-value.has-i-dot:not(.is-open) input,div.form-like .textarea-wrapper.with-value.has-i-dot:not(.is-open) input,form .input-wrapper.with-value.has-i-dot:not(.is-open) input,form .textarea-wrapper.with-value.has-i-dot:not(.is-open) input{padding-left:15px!important}div.form-like .input-wrapper .inline-btn,div.form-like .textarea-wrapper .inline-btn,form .input-wrapper .inline-btn,form .textarea-wrapper .inline-btn{height:50px;margin-left:-1px}div.form-like .input-wrapper .inline-btn.btn-look-alike,div.form-like .textarea-wrapper .inline-btn.btn-look-alike,form .input-wrapper .inline-btn.btn-look-alike,form .textarea-wrapper .inline-btn.btn-look-alike{height:35px}div.form-like .input-wrapper .info-text,div.form-like .textarea-wrapper .info-text,form .input-wrapper .info-text,form .textarea-wrapper .info-text{display:none;font-size:12px;line-height:18px;font-style:italic;padding-top:5px}div.form-like .input-wrapper.with-desc .info-text,div.form-like .textarea-wrapper.with-desc .info-text,form .input-wrapper.with-desc .info-text,form .textarea-wrapper.with-desc .info-text{display:flex}div.form-like .input-wrapper.with-desc .desc-icon,div.form-like .textarea-wrapper.with-desc .desc-icon,form .input-wrapper.with-desc .desc-icon,form .textarea-wrapper.with-desc .desc-icon{color:#089e8a}div.form-like .input-wrapper.ddl-wrapper:not(.with-value) .dll-label,div.form-like .textarea-wrapper.ddl-wrapper:not(.with-value) .dll-label,form .input-wrapper.ddl-wrapper:not(.with-value) .dll-label,form .textarea-wrapper.ddl-wrapper:not(.with-value) .dll-label{color:#aeb0b3;font-size:16px;font-weight:400}div.form-like .input-wrapper.ddl-wrapper.with-value .dll-label,div.form-like .textarea-wrapper.ddl-wrapper.with-value .dll-label,form .input-wrapper.ddl-wrapper.with-value .dll-label,form .textarea-wrapper.ddl-wrapper.with-value .dll-label{font-size:16px;font-weight:400}div.form-like .input-wrapper .desc-icon,div.form-like .input-wrapper .for-label-icon,div.form-like .textarea-wrapper .desc-icon,div.form-like .textarea-wrapper .for-label-icon,form .input-wrapper .desc-icon,form .input-wrapper .for-label-icon,form .textarea-wrapper .desc-icon,form .textarea-wrapper .for-label-icon{position:absolute;right:0;cursor:pointer}div.form-like .input-wrapper .desc-icon:hover,div.form-like .input-wrapper .for-label-icon:hover,div.form-like .textarea-wrapper .desc-icon:hover,div.form-like .textarea-wrapper .for-label-icon:hover,form .input-wrapper .desc-icon:hover,form .input-wrapper .for-label-icon:hover,form .textarea-wrapper .desc-icon:hover,form .textarea-wrapper .for-label-icon:hover{color:#089e8a}div.form-like .input-wrapper .btn-look-alike,div.form-like .textarea-wrapper .btn-look-alike,form .input-wrapper .btn-look-alike,form .textarea-wrapper .btn-look-alike{padding:7px 10px 6px;line-height:27px}div.form-like .input-wrapper .ddl,div.form-like .textarea-wrapper .ddl,form .input-wrapper .ddl,form .textarea-wrapper .ddl{height:35px;border:1px solid #d8d8d8}div.form-like .input-wrapper .ddl:hover,div.form-like .textarea-wrapper .ddl:hover,form .input-wrapper .ddl:hover,form .textarea-wrapper .ddl:hover{background:#f9f9f9}div.form-like .input-wrapper .ddl:focus,div.form-like .textarea-wrapper .ddl:focus,form .input-wrapper .ddl:focus,form .textarea-wrapper .ddl:focus{outline:none;background:#f9f9f9}div.form-like .input-wrapper .ddl ul,div.form-like .textarea-wrapper .ddl ul,form .input-wrapper .ddl ul,form .textarea-wrapper .ddl ul{right:-1px;left:-1px}div.form-like .input-wrapper i.input-icon,div.form-like .input-wrapper i.selection-icon,div.form-like .textarea-wrapper i.input-icon,div.form-like .textarea-wrapper i.selection-icon,form .input-wrapper i.input-icon,form .input-wrapper i.selection-icon,form .textarea-wrapper i.input-icon,form .textarea-wrapper i.selection-icon{position:absolute;left:8px;top:35px;font-size:22px;color:#aeb0b3;z-index:3000}div.form-like .input-wrapper i.input-icon.i-plus,div.form-like .input-wrapper i.selection-icon.i-plus,div.form-like .textarea-wrapper i.input-icon.i-plus,div.form-like .textarea-wrapper i.selection-icon.i-plus,form .input-wrapper i.input-icon.i-plus,form .input-wrapper i.selection-icon.i-plus,form .textarea-wrapper i.input-icon.i-plus,form .textarea-wrapper i.selection-icon.i-plus{color:green;top:37px}div.form-like .input-wrapper.with-value .ddl label,div.form-like .textarea-wrapper.with-value .ddl label,form .input-wrapper.with-value .ddl label,form .textarea-wrapper.with-value .ddl label{color:#1a1a1a}div.form-like .input-wrapper.has-i i.input-icon,div.form-like .textarea-wrapper.has-i i.input-icon,form .input-wrapper.has-i i.input-icon,form .textarea-wrapper.has-i i.input-icon{top:20px;left:10px}div.form-like .input-wrapper.has-i input,div.form-like .textarea-wrapper.has-i input,form .input-wrapper.has-i input,form .textarea-wrapper.has-i input{padding-left:35px;border-radius:20px}div.form-like .input-wrapper.has-focus-i .input-icon,div.form-like .textarea-wrapper.has-focus-i .input-icon,form .input-wrapper.has-focus-i .input-icon,form .textarea-wrapper.has-focus-i .input-icon{display:none}div.form-like .input-wrapper.has-focus-i .input-icon.do-show,div.form-like .textarea-wrapper.has-focus-i .input-icon.do-show,form .input-wrapper.has-focus-i .input-icon.do-show,form .textarea-wrapper.has-focus-i .input-icon.do-show{display:inline-block}div.form-like .input-wrapper.has-focus-i .selection-icon,div.form-like .textarea-wrapper.has-focus-i .selection-icon,form .input-wrapper.has-focus-i .selection-icon,form .textarea-wrapper.has-focus-i .selection-icon{display:none}div.form-like .input-wrapper.has-focus-i input,div.form-like .textarea-wrapper.has-focus-i input,form .input-wrapper.has-focus-i input,form .textarea-wrapper.has-focus-i input{transition:padding-left .25s}div.form-like .input-wrapper.has-focus-i.focused:not(.with-value) input,div.form-like .textarea-wrapper.has-focus-i.focused:not(.with-value) input,form .input-wrapper.has-focus-i.focused:not(.with-value) input,form .textarea-wrapper.has-focus-i.focused:not(.with-value) input{padding-left:35px}div.form-like .input-wrapper.has-focus-i.focused:not(.with-value) .input-icon,div.form-like .textarea-wrapper.has-focus-i.focused:not(.with-value) .input-icon,form .input-wrapper.has-focus-i.focused:not(.with-value) .input-icon,form .textarea-wrapper.has-focus-i.focused:not(.with-value) .input-icon{display:inline-block!important}div.form-like .input-wrapper.has-focus-i.with-value.has-selection-i input,div.form-like .textarea-wrapper.has-focus-i.with-value.has-selection-i input,form .input-wrapper.has-focus-i.with-value.has-selection-i input,form .textarea-wrapper.has-focus-i.with-value.has-selection-i input{padding-left:35px}div.form-like .input-wrapper.has-focus-i.with-value.has-selection-i i.selection-icon,div.form-like .textarea-wrapper.has-focus-i.with-value.has-selection-i i.selection-icon,form .input-wrapper.has-focus-i.with-value.has-selection-i i.selection-icon,form .textarea-wrapper.has-focus-i.with-value.has-selection-i i.selection-icon{display:inline-block}div.form-like .input-wrapper.first,div.form-like .textarea-wrapper.first,form .input-wrapper.first,form .textarea-wrapper.first{margin-top:0}div.form-like .input-wrapper.click-able,div.form-like .textarea-wrapper.click-able,form .input-wrapper.click-able,form .textarea-wrapper.click-able{cursor:pointer}div.form-like .input-wrapper.click-able input,div.form-like .input-wrapper.click-able label,div.form-like .textarea-wrapper.click-able input,div.form-like .textarea-wrapper.click-able label,form .input-wrapper.click-able input,form .input-wrapper.click-able label,form .textarea-wrapper.click-able input,form .textarea-wrapper.click-able label{cursor:inherit}div.form-like .input-wrapper.is-open input,div.form-like .textarea-wrapper.is-open input,form .input-wrapper.is-open input,form .textarea-wrapper.is-open input{z-index:2000}div.form-like .input-wrapper.margin-top20,div.form-like .textarea-wrapper.margin-top20,form .input-wrapper.margin-top20,form .textarea-wrapper.margin-top20{margin-top:20px}div.form-like .input-wrapper .inline-link,div.form-like .textarea-wrapper .inline-link,form .input-wrapper .inline-link,form .textarea-wrapper .inline-link{position:absolute;right:10px;top:27px;padding:10px;z-index:1}div.form-like .input-wrapper .switch,div.form-like .textarea-wrapper .switch,form .input-wrapper .switch,form .textarea-wrapper .switch{height:48px}div.form-like .input-wrapper .switch .slider:before,div.form-like .textarea-wrapper .switch .slider:before,form .input-wrapper .switch .slider:before,form .textarea-wrapper .switch .slider:before{height:40px}div.form-like .input-wrapper .for-label,div.form-like .textarea-wrapper .for-label,form .input-wrapper .for-label,form .textarea-wrapper .for-label{position:relative;color:#777;font-size:15px;padding-bottom:5px;padding-right:20px}div.form-like .input-wrapper .for-label small,div.form-like .textarea-wrapper .for-label small,form .input-wrapper .for-label small,form .textarea-wrapper .for-label small{text-transform:lowercase;font-size:100%}div.form-like .input-wrapper .for-label.no-go,div.form-like .textarea-wrapper .for-label.no-go,form .input-wrapper .for-label.no-go,form .textarea-wrapper .for-label.no-go{cursor:default}div.form-like .input-wrapper .for-label.req:after,div.form-like .textarea-wrapper .for-label.req:after,form .input-wrapper .for-label.req:after,form .textarea-wrapper .for-label.req:after{position:absolute;padding-left:0;margin-left:3px;content:\" *\";font-size:23px;color:red}div.form-like .input-wrapper .error-label,div.form-like .textarea-wrapper .error-label,form .input-wrapper .error-label,form .textarea-wrapper .error-label{text-align:center;color:red;font-size:13px;padding-top:5px;display:none}div.form-like .input-wrapper.invalid .ddl,div.form-like .input-wrapper.invalid .file-label,div.form-like .input-wrapper.invalid .inline-btn,div.form-like .input-wrapper.invalid input,div.form-like .input-wrapper.invalid textarea,div.form-like .textarea-wrapper.invalid .ddl,div.form-like .textarea-wrapper.invalid .file-label,div.form-like .textarea-wrapper.invalid .inline-btn,div.form-like .textarea-wrapper.invalid input,div.form-like .textarea-wrapper.invalid textarea,form .input-wrapper.invalid .ddl,form .input-wrapper.invalid .file-label,form .input-wrapper.invalid .inline-btn,form .input-wrapper.invalid input,form .input-wrapper.invalid textarea,form .textarea-wrapper.invalid .ddl,form .textarea-wrapper.invalid .file-label,form .textarea-wrapper.invalid .inline-btn,form .textarea-wrapper.invalid input,form .textarea-wrapper.invalid textarea{border:1px solid red;box-shadow:0 0 1px red}div.form-like .input-wrapper.invalid .for-label,div.form-like .input-wrapper.invalid .inline-btn,div.form-like .textarea-wrapper.invalid .for-label,div.form-like .textarea-wrapper.invalid .inline-btn,form .input-wrapper.invalid .for-label,form .input-wrapper.invalid .inline-btn,form .textarea-wrapper.invalid .for-label,form .textarea-wrapper.invalid .inline-btn{color:red}.input-file{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.img-input-wrapper .delete-icon{display:none}.img-input-wrapper.with-value .delete-icon{color:#aeb0b3;position:absolute;right:10px;top:20px;display:flex}.img-input-wrapper.with-value .delete-icon:hover{color:red}.file-label{flex:1;margin:0;font-size:16px;appearance:none;border-radius:none;resize:none;color:#aeb0b3;padding:12px;border:1px solid #f0f0f0;z-index:1;min-width:100px;background:#fff;transition:background .25s;cursor:pointer;white-space:nowrap;overflow:hidden;box-sizing:border-box;box-shadow:inset 0 0 1px 0 #d8d8d8}.file-label .span-label{padding:0 5px 5px 0;display:flex}.file-label .span-label.with-value{cursor:pointer}.file-label .span-label.with-value:hover:after{color:red}.file-label .span-label.with-value:after{font-family:ieo;color:#aeb0b3;content:\"p\";position:relative;top:1px}.file-label.with-inline-preview{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;border:1px dotted #aeb0b3;border-radius:2px;position:relative}.file-label.with-inline-preview .preview-img{max-height:100px;height:100%}.file-label:focus,.file-label:hover{background:#f9f9f9}.file-label:focus{outline:none}.are-you-sure-wrapper .switch .slider:before{content:\"YES?\"}.switch{position:relative;display:inline-block;min-width:60px;height:34px}.switch input{display:none}.switch input:checked+.slider:before{transform:translateX(12px);content:\"Yes\";color:#089e8a}.switch.onOff input:checked+.slider:before{content:\"On\"}.switch.onOff .slider:before{content:\"Off\"}.switch input:checked+.slider{background-color:#089e8a}.switch input:focus+.slider{box-shadow:0 0 1px #089e8a}.switch.red input:checked+.slider{background:red}.switch.red .switch-lb,.switch.red input:checked+.slider:before{color:red}.switch.red .slider{background:red;background:rgba(255,0,0,.25)}.switch.red .slider:before{color:red;color:rgba(255,0,0,.5)}.switch.red input:focus+.slider{box-shadow:0 0 1px red}.switch .switch-lb{position:absolute;right:65px;padding-top:9px;color:#aeb0b3;font-weight:200}.switch .slider{cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#f0f0f0;border-radius:5px}.switch .slider,.switch .slider:before{position:absolute;-webkit-transition:.2s;transition:.2s}.switch .slider:before{content:\"No\";display:flex;align-items:center;justify-content:center;border-radius:4px;height:26px;width:40px;left:4px;bottom:4px;background-color:#fff;color:#aeb0b3}.switch .slider.from-attr:before{content:\"\"}.check{position:relative;display:inline-block;width:25px;height:25px}.check.small{width:20px;height:20px}.check.small input:checked+.checker:before{left:4px;top:0;font-size:16px}.check input{display:none}.check input:checked+.checker{border-color:#089e8a}.check input:focus+.checker{box-shadow:0 0 1px #089e8a}.check input:checked+.checker:before{transform:translateX(0);content:\"\\2713\";color:#089e8a;left:4px;top:0;position:absolute;font-size:20px}.check .checker{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#fff;border-radius:0;border:1px solid #777}.table{align-items:flex-start;justify-content:flex-start;flex-direction:column}.table,.table .t-row{display:flex;width:100%}.table .t-row.t-header{background:#fff;margin-bottom:1px;box-shadow:0 1px 1px #777;z-index:1}.table .t-row.t-header .t-cell{background:#f0f0f0;height:30px;border-top:1px solid #fff}.table .t-row.t-header .t-cell.sortable{cursor:pointer}.table .t-row.t-header .t-cell.sortable:hover span:after{display:inherit}.table .t-row.t-header .t-cell.sortable.sorter{box-shadow:inset 0 10px 30px -10px #aeb0b3;border-top:1px solid #f0f0f0}.table .t-row.t-header .t-cell.sortable.sorter span:after{display:inherit}.table .t-row.t-header .t-cell.sortable.up span:after{content:\"\\25B2\"}.table .t-row.t-header .t-cell.sortable.down span:after{content:\"\\25BC\"}.table .t-row.t-header .t-cell.sortable span{position:relative}.table .t-row.t-header .t-cell.sortable span:after{font-size:12px;color:#777;position:absolute;right:-15px;top:3px;display:none}.table .t-row .t-cell{width:100%;padding:10px;margin-right:1px;line-height:normal;display:flex;align-items:center;justify-content:center}.table .t-row .t-cell:last-child{margin-right:0}.table .t-row .t-cell.width-auto{width:auto}.table .t-row .t-cell.width-100{width:100px;min-width:100px}.table .t-row .t-cell.width-110{width:110px;min-width:110px}.table .t-row .t-cell.width-130{width:130px;min-width:130px}.table .t-row .t-cell.width-40{width:40px;min-width:40px}.table .t-row .t-cell.min-120{min-width:120px}.table .t-row .t-cell.h-left-aligned{justify-content:flex-start}.table .t-body{background:#f0f0f0;flex-direction:column;width:100%}.table .t-body .t-row{margin-top:1px;width:100%;min-height:50px;background:#fff}.table .t-body .t-row a{flex-direction:row;display:flex;width:100%}.table .t-body .t-row:first-child{margin-top:0}.table .t-body .t-row:last-child{border-bottom:1px solid #f0f0f0}.table .t-body .t-row .t-cell{border-right:1px solid #f0f0f0;margin:0}.paginator{position:relative;top:-2px;margin:0;align-self:normal;border-top:2px solid #f0f0f0;align-items:center;justify-content:center}.paginator .paginator-item{position:relative;top:-2px;min-width:20px;text-align:center;cursor:pointer;font-size:20px;padding:20px;color:#777}.paginator .paginator-item:hover:not(.active){color:#1a1a1a}.paginator .paginator-item.active{border-top:2px solid #089e8a;padding-top:18px;color:#089e8a}.paginator .paginator-item.prev{width:auto;order:-1}.paginator .paginator-item.prev:before{content:\"\\226A\";padding-right:5px}.paginator .paginator-item.next{width:auto;order:1}.paginator .paginator-item.next:after{content:\"\\226B\";padding-left:5px}.paginator button.ddl{order:2}header.grid{height:40px;width:100%;align-items:normal;background:#f9f9f9;border:1px solid #d8d8d8;overflow:hidden}header.grid .col[data-sort-on]:hover{background:#f0f0f0}header.grid .col{cursor:pointer;padding:0 5px;border-right:1px solid #d8d8d8}header.grid .col:last-child{border-right:0}header.grid .col.active .sort-icon{display:flex}header.grid .col.active.descending .sort-icon:before{content:\"q\"}header.grid .col .col-lb{font-size:14px;padding:0 5px}header.grid .col .sort-icon{display:none;font-family:ieo;font-style:normal;font-size:10px;padding-left:5px;color:#777}header.grid .col .sort-icon:before{content:\"j\"}.grid{box-sizing:border-box;align-items:center}.grid.grid-body{font-size:12px}.grid.grid-body .col{padding:5px}.grid .col{box-sizing:border-box;align-items:center;justify-content:center;height:100%}.grid .col:not(.fixed-width){flex:1}.grid .col a{appearance:none;outline:0}html{background:#f9f9f9}html body{-webkit-font-smoothing:antialiased;-webkit-text-size-adjust:100%;-moz-osx-font-smoothing:grayscale;font-family:FaktPro-Blond,Helvetica Neue,Helvetica,Arial,sans-serif;color:#1a1a1a;font-size:17px;letter-spacing:1px;overflow-x:hidden;background:#fff;min-width:260px}html body .ad-wrapper{width:100%;min-height:100px;align-items:center;justify-content:center;text-align:center}html body .ad-wrapper ins{width:100%}html body #sections{background:#f9f9f9}html body #sections.app-state{padding-top:0}html body #sections>section{width:100%;flex-direction:column}html body.no-scroll{overflow:hidden}html body #overlay{position:fixed;top:0;right:0;left:0;bottom:0;background:rgba(0,0,0,.1);z-index:1000}html body #betaInfo{position:fixed;width:300px;height:200px;background:#fff;box-shadow:0 0 150px 50px #aeb0b3;top:50%;left:50%;margin-top:-100px;margin-left:-150px;z-index:2000;box-sizing:border-box}html body #betaInfo .header-comp{padding:10px;border-bottom:1px solid #d8d8d8;width:100%;position:relative;box-sizing:border-box}html body #betaInfo .header-comp a img{width:120px}html body #betaInfo .header-comp .beta2{color:#fff;padding:5px 0;width:52px;text-align:center;font-weight:600;background:#08ab97;transform:rotate(90deg);position:absolute;top:14px;right:-14px;cursor:pointer;font-size:12px;border-bottom:1px solid #089e8a}html body #betaInfo p.info-txt{font-size:12px;line-height:1.3;color:#777;text-align:justify;padding:10px;box-sizing:border-box}html body #betaInfo p.info-txt a{font-size:inherit;font-weight:inherit;color:#2a5db0}", ""]);

// exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "i:before{content:\"v\";font-family:ieo}i.i-info{color:#d8d8d8}footer.app-footer{width:100%;background:#1a1a1a;display:flex}footer.app-footer.app-state{display:none}footer.app-footer .fixed-content-container{padding:20px 0;align-items:center}footer.app-footer .fixed-content-container p{color:#777;text-align:center}footer.app-footer .fixed-content-container p:after{content:\"|\";padding:0 10px}footer.app-footer .fixed-content-container a{color:#aeb0b3}footer.app-footer .fixed-content-container a:hover{color:#f0f0f0}footer.app-footer .fixed-content-container a.terms:after{content:\"|\";padding:0 10px}@media (max-width:600px){footer.app-footer .fixed-content-container{flex-direction:column-reverse;align-items:center}footer.app-footer .fixed-content-container p:after{display:none}footer.app-footer .fixed-content-container a{margin-bottom:10px}footer.app-footer .fixed-content-container a.terms:after{display:none}}", ""]);

// exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "i:before{content:\"v\";font-family:ieo}i.i-info{color:#d8d8d8}header.main-header{position:fixed;background:#fff;min-width:200px;z-index:100;top:0;width:100%;border-bottom:1px solid #d8d8d8;padding:0;height:79px;display:flex}header.main-header .beta{color:#fff;padding:5px 17px;font-weight:600;background:#08ab97;transform:rotate(90deg);margin-left:5px;position:absolute;bottom:25px;right:-26px;cursor:pointer;border-bottom:1px solid #089e8a}header.main-header.app-state{display:none}header.main-header .fixed-content-container{height:100%}header.main-header .fixed-content-container nav{justify-content:flex-end;height:100%}header.main-header .fixed-content-container nav .link-wrapper{height:100%}header.main-header .fixed-content-container nav .link-wrapper a{padding:10px 20px 6px;height:100%;box-sizing:border-box;border-bottom:4px solid #fff;font-weight:400;font-size:16px;color:#555;text-transform:uppercase;display:flex;align-items:center}header.main-header .fixed-content-container nav .link-wrapper a:hover:not(.active){color:#1a1a1a;border-color:#f9f9f9;text-decoration:none;background:#f9f9f9}header.main-header .fixed-content-container nav .link-wrapper a.unique,header.main-header .fixed-content-container nav .link-wrapper a:hover:not(.active).unique{color:#9c27b0}header.main-header .fixed-content-container nav .link-wrapper a.active{background:inherit;color:inherit;border-color:#089e8a;color:#089e8a}header.main-header .fixed-content-container nav .link-wrapper a.active.unique{color:#9c27b0;border-color:#9c27b0}header.main-header .fixed-content-container nav .header-menu{width:30px;height:30px;cursor:pointer;display:none;justify-content:center}header.main-header .fixed-content-container nav .header-menu span{height:2px;width:100%;margin-top:4px;background:#aeb0b3;transition:background .25s}header.main-header .fixed-content-container nav .header-menu span:first-child{margin-top:0}header.main-header .fixed-content-container nav .header-menu:hover span{background:#777}@media (max-width:1000px){header.main-header .fixed-content-container nav .link-wrapper a{padding:10px 10px 6px;font-size:14px}}@media (max-width:800px){header.main-header .fixed-content-container nav .link-wrapper{display:none;position:absolute;width:180px;top:20px;padding:0;flex-direction:column;border:1px solid #f0f0f0;box-shadow:0 0 50px 5px #aeb0b3;background:#fff;height:auto}header.main-header .fixed-content-container nav .link-wrapper.active{display:flex}header.main-header .fixed-content-container nav .link-wrapper.active a{width:100%;padding:15px;border-bottom:0;line-height:inherit;justify-content:left}header.main-header .fixed-content-container nav .link-wrapper.active a.active{color:#089e8a}header.main-header .fixed-content-container nav .header-menu{display:flex;margin-right:20px}}", ""]);

// exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "@font-face{font-family:ieo;src:url(" + __webpack_require__(15) + ");src:url(" + __webpack_require__(15) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(51) + ") format(\"woff\"),url(" + __webpack_require__(50) + ") format(\"truetype\"),url(" + __webpack_require__(49) + "#ieo) format(\"svg\");font-weight:400;font-style:normal}[data-icon]:before{content:attr(data-icon)}[class*=\" i-\"]:before,[class^=i-]:before,[data-icon]:before{font-family:ieo!important;font-style:normal!important;font-weight:400!important;font-variant:normal!important;text-transform:none!important;speak:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.i-google:before{content:\"a\"}.i-facebook:before{content:\"b\"}.i-lock:before{content:\"c\"}.i-sign-in:before{content:\"d\"}.i-sign-out:before{content:\"e\"}.i-options:before{content:\"g\"}.i-dashboard:before{content:\"h\"}.i-budget:before{content:\"i\"}.i-report:before{content:\"k\"}.i-tools:before{content:\"l\"}.i-tracker:before{content:\"m\"}.i-email:before{content:\"n\"}.i-plus:before{content:\"o\"}.i-cancel:before{content:\"p\"}.i-list:before{content:\"y\"}.i-search:before{content:\"K\"}.i-question:before{content:\"L\"}.i-info:before{content:\"M\"}.i-attachment:before{content:\"N\"}.i-income:before{content:\"Q\"}.i-expense:before{content:\"R\"}.i-less:before{content:\"W\"}.i-more:before{content:\"X\"}.i-save:before{content:\"T\"}.i-edit:before{content:\"f\"}.i-back:before{content:\"Y\"}.i-dot:before{content:\"0\"}.i-recurring:before{content:\"7\"}.i-arrow-up:before{content:\"j\"}.i-arrow-down:before{content:\"q\"}.i-arrow-left:before{content:\"r\"}.i-arrow-right:before{content:\"s\"}.i-level-down:before{content:\"u\"}.i-n-a:before{content:\"v\"}.i-balance:before{content:\"t\"}.i-checked:before{content:\"w\"}.i-unchecked:before{content:\"x\"}.i-allocation:before{content:\"z\"}.i-clone:before{content:\"A\"}.i-delete:before{content:\"C\"}.i-advertising:before{content:\"B\"}.i-truck:before{content:\"E\"}.i-contractors:before{content:\"D\"}.i-edu:before{content:\"F\"}.i-entertainment:before{content:\"G\"}.i-office:before{content:\"H\"}.i-personal:before{content:\"I\"}.i-pro:before{content:\"O\"}.i-supplies:before{content:\"P\"}.i-travel:before{content:\"S\"}.i-utilities:before{content:\"U\"}.i-earned-income:before{content:\"V\"}.i-portfolio:before{content:\"1\"}.i-savings:before{content:\"2\"}.i-invest:before{content:\"3\"}.i-lending:before{content:\"4\"}.i-alternative:before{content:\"6\"}.i-debt:before{content:\"5\"}.i-leisure:before{content:\"8\"}.i-pdf:before{content:\"!\"}.i-calculator:before{content:'\"'}.i-reports:before{content:\"9\"}.i-home:before{content:\"#\"}.i-check:before{content:\"$\"}.i-calendar:before{content:\"%\"}.i-tag:before{content:\"&\"}.i-house:before{content:\"J\"}.i-unearned-income:before{content:\"Z\"}", ""]);

// exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fontastic/fonts/ieo.svg";

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fontastic/fonts/ieo.ttf";

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "src/assets/fontastic/fonts/ieo.woff";

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = "<footer id={{_UID_}} class=\"app-footer indexed\"> <div class=fixed-content-container> <p>© 2018 iExpenseOnline.com</p> <a href=/terms-of-service class=terms>Terms of Service</a> <a href=/contact-us class=contact>Contact Us</a> </div> </footer>";

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = "<header id={{_UID_}} class=\"main-header indexed\"> <div class=\"fixed-content-container v-aligned\"> <a href=/ class=logo> <img src=/assets/icon/logo.png alt=logo role=presentation> </a> <span class=\"beta hidden\">BETA</span> <nav class=\"v-aligned pull-right\"> <div class=\"link-wrapper animated quick\"> <a href=/about class=hidden>About Us</a> <a href=/features class=\"\">Features</a> <a href=/testimonials class=\"\">Testimonials</a> <a href=/contact-us class=\"\">Contact Us</a> <a href=/log-in class=\"\">Log In</a> <a href=/sign-up class=unique>Sign Up</a> </div> <div class=\"header-menu v-aligned column\"> <span></span> <span></span> <span></span> </div> </nav> </div> </header>";

/***/ }),
/* 54 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(45);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./Index.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./Index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(46);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Footer.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Footer.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(47);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(6)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Header.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./Header.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(16);


/***/ })
],[58]);


// WEBPACK FOOTER //
// bundle.js